// 1. DATA SOURCE (Your clean JSON) 
const officialsData = [
  {
    "FirstName": "Mike",
    "LastName": "Dunleavy",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "907-465-3500",
    "Address": "P.O. Box 110001, Juneau, AK 99811",
    "WebsiteURL": "https://aws.state.ak.us/CrmForms/Home/WebRequest",
    "FacebookURL": "https://facebook.com/GovDunleavy",
    "XURL": "https://x.com/GovDunleavy",
    "State": "AK"
  },
  {
    "FirstName": "Kay",
    "LastName": "Ivey",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "334-242-7100",
    "Address": "600 Dexter Ave, Montgomery, AL 36130",
    "WebsiteURL": "https://contact.governor.alabama.gov/contact.aspx",
    "FacebookURL": "https://facebook.com/GovernorKayIvey",
    "XURL": "https://x.com/GovernorKayIvey",
    "State": "AL"
  },
  {
    "FirstName": "Nikolao",
    "LastName": "Pula",
    "Role": "Acting Gov",
    "Division": "State",
    "Party": "IND",
    "Phone": "684-633-4116",
    "Address": "Executive Office Bldg, Pago Pago, AS 96799",
    "WebsiteURL": "",
    "FacebookURL": "https://facebook.com/ASG_Gov",
    "XURL": "https://x.com/ASG_Gov",
    "State": "AS"
  },
  {
    "FirstName": "Katie",
    "LastName": "Hobbs",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "602-542-4331",
    "Address": "1700 W Washington St, Phoenix, AZ 85007",
    "WebsiteURL": "https://azgovernor.gov/engage",
    "FacebookURL": "https://facebook.com/GovernorHobbs",
    "XURL": "https://x.com/GovernorHobbs",
    "State": "AZ"
  },
  {
    "FirstName": "Sarah",
    "LastName": "Huckabee Sanders",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "501-682-2345",
    "Address": "500 Woodlane St, Little Rock, AR 72201",
    "WebsiteURL": "https://governor.arkansas.gov/contact-us/",
    "FacebookURL": "https://facebook.com/GovSanders",
    "XURL": "https://x.com/GovSanders",
    "State": "AR"
  },
  {
    "FirstName": "Gavin",
    "LastName": "Newsom",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "916-445-2841",
    "Address": "1021 O St, Suite 9000, Sacramento, CA 95814",
    "WebsiteURL": "https://www.gov.ca.gov/contact/",
    "FacebookURL": "https://facebook.com/CAgovernor",
    "XURL": "https://x.com/CAgovernor",
    "State": "CA"
  },
  {
    "FirstName": "Jared",
    "LastName": "Polis",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "303-866-2885",
    "Address": "136 State Capitol, Denver, CO 80203",
    "WebsiteURL": "https://www.colorado.gov/governor/contact",
    "FacebookURL": "https://facebook.com/GovofCO",
    "XURL": "https://x.com/GovofCO",
    "State": "CO"
  },
  {
    "FirstName": "Ned",
    "LastName": "Lamont",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "860-566-4840",
    "Address": "210 Capitol Ave, Hartford, CT 06106",
    "WebsiteURL": "https://portal.ct.gov/Office-of-the-Governor/Contact",
    "FacebookURL": "https://facebook.com/GovNedLamont",
    "XURL": "https://x.com/GovNedLamont",
    "State": "CT"
  },
  {
    "FirstName": "Matt",
    "LastName": "Meyer",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "302-744-4101",
    "Address": "150 MLK Jr Blvd S, Dover, DE 19901",
    "WebsiteURL": "https://governor.delaware.gov/contact/",
    "FacebookURL": "https://facebook.com/MattMeyerDE",
    "XURL": "https://x.com/MattMeyerDE",
    "State": "DE"
  },
  {
    "FirstName": "Ron",
    "LastName": "DeSantis",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "850-488-7146",
    "Address": "400 S Monroe St, Tallahassee, FL 32399",
    "WebsiteURL": "https://www.flgov.com/contact-governor/",
    "FacebookURL": "https://facebook.com/GovRonDeSantis",
    "XURL": "https://x.com/GovRonDeSantis",
    "State": "FL"
  },
  {
    "FirstName": "Brian",
    "LastName": "Kemp",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "404-656-1776",
    "Address": "206 Washington St, Atlanta, GA 30334",
    "WebsiteURL": "https://gov.georgia.gov/contact-us",
    "FacebookURL": "https://facebook.com/GovKemp",
    "XURL": "https://x.com/GovKemp",
    "State": "GA"
  },
  {
    "FirstName": "Lou",
    "LastName": "Leon Guerrero",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "671-472-8931",
    "Address": "Ricardo J. Bordallo Complex, Hagåtña, GU 96910",
    "WebsiteURL": "",
    "FacebookURL": "https://facebook.com/louleonguerrero",
    "XURL": "https://x.com/louleonguerrero",
    "State": "GU"
  },
  {
    "FirstName": "Joshua",
    "LastName": "Green",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "808-586-0034",
    "Address": "State Capitol, Honolulu, HI 96813",
    "WebsiteURL": "https://governor.hawaii.gov/contact-us/",
    "FacebookURL": "https://facebook.com/GovJoshGreen",
    "XURL": "https://x.com/GovJoshGreen",
    "State": "HI"
  },
  {
    "FirstName": "Brad",
    "LastName": "Little",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "208-334-2100",
    "Address": "700 W Jefferson St, Boise, ID 83720",
    "WebsiteURL": "https://gov.idaho.gov/contact/",
    "FacebookURL": "https://facebook.com/GovernorLittle",
    "XURL": "https://x.com/GovernorLittle",
    "State": "ID"
  },
  {
    "FirstName": "J.B.",
    "LastName": "Pritzker",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "217-782-6830",
    "Address": "207 State House, Springfield, IL 62706",
    "WebsiteURL": "https://gov.illinois.gov/contact-us.html",
    "FacebookURL": "https://facebook.com/GovPritzker",
    "XURL": "https://x.com/GovPritzker",
    "State": "IL"
  },
  {
    "FirstName": "Mike",
    "LastName": "Braun",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "317-232-4567",
    "Address": "200 W Washington St, Indianapolis, IN 46204",
    "WebsiteURL": "https://www.in.gov/gov/contact/",
    "FacebookURL": "https://facebook.com/GovBraun",
    "XURL": "https://x.com/GovBraun",
    "State": "IN"
  },
  {
    "FirstName": "Kim",
    "LastName": "Reynolds",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "515-281-5211",
    "Address": "1007 E Grand Ave, Des Moines, IA 50319",
    "WebsiteURL": "https://governor.iowa.gov/contact",
    "FacebookURL": "https://facebook.com/IAGovernor",
    "XURL": "https://x.com/IAGovernor",
    "State": "IA"
  },
  {
    "FirstName": "Laura",
    "LastName": "Kelly",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "785-296-3232",
    "Address": "300 SW 10th Ave, Topeka, KS 66612",
    "WebsiteURL": "https://governor.kansas.gov/contact/",
    "FacebookURL": "https://facebook.com/GovLauraKelly",
    "XURL": "https://x.com/GovLauraKelly",
    "State": "KS"
  },
  {
    "FirstName": "Andy",
    "LastName": "Beshear",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "502-564-2611",
    "Address": "700 Capital Ave, Frankfort, KY 40601",
    "WebsiteURL": "https://governor.ky.gov/contact-us",
    "FacebookURL": "https://facebook.com/GovAndyBeshear",
    "XURL": "https://x.com/GovAndyBeshear",
    "State": "KY"
  },
  {
    "FirstName": "Jeff",
    "LastName": "Landry",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "225-342-7015",
    "Address": "P.O. Box 94004, Baton Rouge, LA 70804",
    "WebsiteURL": "https://gov.louisiana.gov/contact/",
    "FacebookURL": "https://facebook.com/LAGov",
    "XURL": "https://x.com/LAGov",
    "State": "LA"
  },
  {
    "FirstName": "Janet T.",
    "LastName": "Mills",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "207-287-3531",
    "Address": "1 State House Station, Augusta, ME 04333",
    "WebsiteURL": "https://www.maine.gov/governor/mills/contact",
    "FacebookURL": "https://facebook.com/GovJanetMills",
    "XURL": "https://x.com/GovJanetMills",
    "State": "ME"
  },
  {
    "FirstName": "Wes",
    "LastName": "Moore",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "410-974-3901",
    "Address": "100 State Circle, Annapolis, MD 21401",
    "WebsiteURL": "https://governor.maryland.gov/contact-the-governor/",
    "FacebookURL": "https://facebook.com/GovWesMoore",
    "XURL": "https://x.com/GovWesMoore",
    "State": "MD"
  },
  {
    "FirstName": "Maura",
    "LastName": "Healey",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "617-725-4005",
    "Address": "24 Beacon St, Rm 280, Boston, MA 02133",
    "WebsiteURL": "https://www.mass.gov/forms/email-the-governors-office",
    "FacebookURL": "https://facebook.com/MassGovernor",
    "XURL": "https://x.com/MassGovernor",
    "State": "MA"
  },
  {
    "FirstName": "Gretchen",
    "LastName": "Whitmer",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "517-373-3400",
    "Address": "P.O. Box 30013, Lansing, MI 48909",
    "WebsiteURL": "https://www.michigan.gov/whitmer/contact",
    "FacebookURL": "https://facebook.com/GovWhitmer",
    "XURL": "https://x.com/GovWhitmer",
    "State": "MI"
  },
  {
    "FirstName": "Tim",
    "LastName": "Walz",
    "Role": "Governor",
    "Division": "State",
    "Party": "DFL",
    "Phone": "651-201-3400",
    "Address": "130 State Capitol, St. Paul, MN 55155",
    "WebsiteURL": "https://mn.gov/governor/contact/",
    "FacebookURL": "https://facebook.com/GovTimWalz",
    "XURL": "https://x.com/GovTimWalz",
    "State": "MN"
  },
  {
    "FirstName": "Tate",
    "LastName": "Reeves",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "601-359-3150",
    "Address": "P.O. Box 139, Jackson, MS 39205",
    "WebsiteURL": "https://www.governorreeves.ms.gov/contact/",
    "FacebookURL": "https://facebook.com/tatereeves",
    "XURL": "https://x.com/tatereeves",
    "State": "MS"
  },
  {
    "FirstName": "Mike",
    "LastName": "Kehoe",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "573-751-3222",
    "Address": "P.O. Box 720, Jefferson City, MO 65102",
    "WebsiteURL": "https://governor.mo.gov/contact-us",
    "FacebookURL": "https://facebook.com/GovMikeKehoe",
    "XURL": "https://x.com/GovMikeKehoe",
    "State": "MO"
  },
  {
    "FirstName": "Greg",
    "LastName": "Gianforte",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "406-444-3111",
    "Address": "P.O. Box 200801, Helena, MT 59620",
    "WebsiteURL": "https://svc.mt.gov/gov/contact/",
    "FacebookURL": "https://facebook.com/GovGianforte",
    "XURL": "https://x.com/GovGianforte",
    "State": "MT"
  },
  {
    "FirstName": "Jim",
    "LastName": "Pillen",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "402-471-2244",
    "Address": "P.O. Box 94848, Lincoln, NE 68509",
    "WebsiteURL": "https://governor.nebraska.gov/contact-form",
    "FacebookURL": "https://facebook.com/TeamPillen",
    "XURL": "https://x.com/TeamPillen",
    "State": "NE"
  },
  {
    "FirstName": "Joe",
    "LastName": "Lombardo",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "775-684-5670",
    "Address": "101 N Carson St, Carson City, NV 89701",
    "WebsiteURL": "https://gov.nv.gov/Forms/Share/",
    "FacebookURL": "https://facebook.com/GovLombardo",
    "XURL": "https://x.com/GovLombardo",
    "State": "NV"
  },
  {
    "FirstName": "Kelly",
    "LastName": "Ayotte",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "603-271-2121",
    "Address": "107 N Main St, Concord, NH 03301",
    "WebsiteURL": "https://new-hampshire.secure.force.com/support/GOV",
    "FacebookURL": "https://facebook.com/GovKellyAyotte",
    "XURL": "https://x.com/GovKellyAyotte",
    "State": "NH"
  },
  {
    "FirstName": "Mikie",
    "LastName": "Sherrill",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "609-292-6000",
    "Address": "P.O. Box 001, Trenton, NJ 08625",
    "WebsiteURL": "https://www.nj.gov/governor/contact/all/",
    "FacebookURL": "https://facebook.com/GovSherrill",
    "XURL": "https://x.com/GovSherrill",
    "State": "NJ"
  },
  {
    "FirstName": "Michelle Lujan",
    "LastName": "Grisham",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "505-476-2200",
    "Address": "490 Old Santa Fe Trail, Santa Fe, NM 87501",
    "WebsiteURL": "https://www.governor.state.nm.us/contact-the-governor/",
    "FacebookURL": "https://facebook.com/GovMLG",
    "XURL": "https://x.com/GovMLG",
    "State": "NM"
  },
  {
    "FirstName": "Kathy",
    "LastName": "Hochul",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "518-474-8390",
    "Address": "State Capitol Bldg, Albany, NY 12224",
    "WebsiteURL": "https://www.governor.ny.gov/content/governor-contact-form",
    "FacebookURL": "https://facebook.com/GovKathyHochul",
    "XURL": "https://x.com/GovKathyHochul",
    "State": "NY"
  },
  {
    "FirstName": "Josh",
    "LastName": "Stein",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "919-814-2000",
    "Address": "20301 Mail Service Ctr, Raleigh, NC 27699",
    "WebsiteURL": "https://governor.nc.gov/contact",
    "FacebookURL": "https://facebook.com/GovJoshStein",
    "XURL": "https://x.com/GovJoshStein",
    "State": "NC"
  },
  {
    "FirstName": "Kelly",
    "LastName": "Armstrong",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "701-328-2200",
    "Address": "600 E Boulevard Ave, Bismarck, ND 58505",
    "WebsiteURL": "https://www.governor.nd.gov/contact",
    "FacebookURL": "https://facebook.com/GovArmstrongND",
    "XURL": "https://x.com/GovArmstrongND",
    "State": "ND"
  },
  {
    "FirstName": "Richard Michael",
    "LastName": "DeWine",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "614-466-3555",
    "Address": "77 S High St, Columbus, OH 43215",
    "WebsiteURL": "https://governor.ohio.gov/contact",
    "FacebookURL": "https://facebook.com/GovMikeDeWine",
    "XURL": "https://x.com/GovMikeDeWine",
    "State": "OH"
  },
  {
    "FirstName": "Kevin",
    "LastName": "Stitt",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "405-521-2342",
    "Address": "2300 N Lincoln Blvd, Oklahoma City, OK 73105",
    "WebsiteURL": "https://oklahoma.gov/governor/contact.html",
    "FacebookURL": "https://facebook.com/GovStitt",
    "XURL": "https://x.com/GovStitt",
    "State": "OK"
  },
  {
    "FirstName": "Tina",
    "LastName": "Kotek",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "503-378-4582",
    "Address": "900 Court St NE, Salem, OR 97301",
    "WebsiteURL": "https://www.oregon.gov/gov/pages/contact.aspx",
    "FacebookURL": "https://facebook.com/GovTinaKotek",
    "XURL": "https://x.com/GovTinaKotek",
    "State": "OR"
  },
  {
    "FirstName": "Josh",
    "LastName": "Shapiro",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "717-787-2500",
    "Address": "508 Main Capitol Bldg, Harrisburg, PA 17120",
    "WebsiteURL": "https://www.governor.pa.gov/contact/",
    "FacebookURL": "https://facebook.com/GovernorShapiro",
    "XURL": "https://x.com/GovernorShapiro",
    "State": "PA"
  },
  {
    "FirstName": "Jenniffer",
    "LastName": "González-Colón",
    "Role": "Governor",
    "Division": "State",
    "Party": "PNP",
    "Phone": "787-721-7000",
    "Address": "La Fortaleza, San Juan, PR 00901",
    "WebsiteURL": "",
    "FacebookURL": "https://facebook.com/GovJenniffer",
    "XURL": "https://x.com/GovJenniffer",
    "State": "PR"
  },
  {
    "FirstName": "Daniel",
    "LastName": "McKee",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "401-222-2080",
    "Address": "82 Smith St, Providence, RI 02903",
    "WebsiteURL": "https://governor.ri.gov/contact/",
    "FacebookURL": "https://facebook.com/GovDanMcKee",
    "XURL": "https://x.com/GovDanMcKee",
    "State": "RI"
  },
  {
    "FirstName": "Henry",
    "LastName": "McMaster",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "803-734-2100",
    "Address": "1100 Gervais St, Columbia, SC 29201",
    "WebsiteURL": "https://scgovernorcontact.force.com/",
    "FacebookURL": "https://facebook.com/henrymcmaster",
    "XURL": "https://x.com/henrymcmaster",
    "State": "SC"
  },
  {
    "FirstName": "Larry",
    "LastName": "Rhoden",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "605-773-3212",
    "Address": "500 E Capitol Ave, Pierre, SD 57501",
    "WebsiteURL": "https://governor.sd.gov/contact/",
    "FacebookURL": "",
    "XURL": "https://x.com/GovLarryRhoden",
    "State": "SD"
  },
  {
    "FirstName": "Bill",
    "LastName": "Lee",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "615-253-7730",
    "Address": "State Capitol, Nashville, TN 37243",
    "WebsiteURL": "https://www.tn.gov/governor/contact-us.html",
    "FacebookURL": "https://facebook.com/GovBillLee",
    "XURL": "https://x.com/GovBillLee",
    "State": "TN"
  },
  {
    "FirstName": "Greg",
    "LastName": "Abbott",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "512-463-2000",
    "Address": "P.O. Box 12428, Austin, TX 78711",
    "WebsiteURL": "https://gov.texas.gov/contact",
    "FacebookURL": "https://facebook.com/GovAbbott",
    "XURL": "https://x.com/GovAbbott",
    "State": "TX"
  },
  {
    "FirstName": "Spencer",
    "LastName": "Cox",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "801-538-1000",
    "Address": "350 N State St, Salt Lake City, UT 84114",
    "WebsiteURL": "https://governor.utah.gov/contact/",
    "FacebookURL": "https://facebook.com/GovCox",
    "XURL": "https://x.com/GovCox",
    "State": "UT"
  },
  {
    "FirstName": "Phil",
    "LastName": "Scott",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "802-828-3333",
    "Address": "109 State St, Montpelier, VT 05609",
    "WebsiteURL": "https://governor.vermont.gov/email",
    "FacebookURL": "https://facebook.com/GovPhilScott",
    "XURL": "https://x.com/GovPhilScott",
    "State": "VT"
  },
  {
    "FirstName": "Abigail",
    "LastName": "Spanberger",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "804-786-2211",
    "Address": "P.O. Box 1475, Richmond, VA 23219",
    "WebsiteURL": "https://www.governor.virginia.gov/constituent-services/",
    "FacebookURL": "https://facebook.com/GovSpanberger",
    "XURL": "https://x.com/GovSpanberger",
    "State": "VA"
  },
  {
    "FirstName": "Bob",
    "LastName": "Ferguson",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "360-902-4111",
    "Address": "P.O. Box 40002, Olympia, WA 98504",
    "WebsiteURL": "https://governor.wa.gov/contact/contact/send-message-governor",
    "FacebookURL": "https://facebook.com/GovFerguson",
    "XURL": "https://x.com/GovFerguson",
    "State": "WA"
  },
  {
    "FirstName": "Patrick",
    "LastName": "Morrisey",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "304-558-2000",
    "Address": "1900 Kanawha Blvd E, Charleston, WV 25305",
    "WebsiteURL": "https://governor.wv.gov/contact/",
    "FacebookURL": "https://facebook.com/GovMorrisey",
    "XURL": "https://x.com/GovMorrisey",
    "State": "WV"
  },
  {
    "FirstName": "Tony",
    "LastName": "Evers",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "608-266-1212",
    "Address": "115 E State Capitol, Madison, WI 53702",
    "WebsiteURL": "https://evers.wi.gov/Pages/connect.aspx",
    "FacebookURL": "https://facebook.com/GovEvers",
    "XURL": "https://x.com/GovEvers",
    "State": "WI"
  },
  {
    "FirstName": "Mark",
    "LastName": "Gordon",
    "Role": "Governor",
    "Division": "State",
    "Party": "R",
    "Phone": "307-777-7434",
    "Address": "200 W 24th St, Cheyenne, WY 82002",
    "WebsiteURL": "https://governor.wyo.gov/contact",
    "FacebookURL": "https://facebook.com/GovernorGordon",
    "XURL": "https://x.com/GovernorGordon",
    "State": "WY"
  },
  {
    "FirstName": "David",
    "LastName": "Apatang",
    "Role": "Lt Gov",
    "Division": "State",
    "Party": "IND",
    "Phone": "670-237-2200",
    "Address": "Capitol Hill, Saipan, MP 96950",
    "WebsiteURL": "",
    "FacebookURL": "https://facebook.com/cnmigov",
    "XURL": "https://x.com/cnmigov",
    "State": "MP"
  },
  {
    "FirstName": "Albert",
    "LastName": "Bryan",
    "Role": "Governor",
    "Division": "State",
    "Party": "D",
    "Phone": "340-774-0001",
    "Address": "21-22 Kongens Gade, St. Thomas, VI 00802",
    "WebsiteURL": "",
    "FacebookURL": "https://facebook.com/GovAlbertBryan",
    "XURL": "https://x.com/GovAlbertBryan",
    "State": "VI"
  },
  {
    "FirstName": "John",
    "LastName": "Boozman",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-4843",
    "Address": "SD-555",
    "WebsiteURL": "https://www.boozman.senate.gov",
    "FacebookURL": "https://facebook.com/senkatiebritt",
    "XURL": "https://x.com/SenKatieBritt",
    "State": "AK"
  },
  {
    "FirstName": "Tom",
    "LastName": "Cotton",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2353",
    "Address": "SR-326",
    "WebsiteURL": "https://www.cotton.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorTuberville",
    "XURL": "https://x.com/SenTuberville",
    "State": "AK"
  },
  {
    "FirstName": "Lisa",
    "LastName": "Murkowski",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6665",
    "Address": "SH-522",
    "WebsiteURL": "https://www.murkowski.senate.gov",
    "FacebookURL": "https://facebook.com/SenLisaMurkowski",
    "XURL": "https://x.com/lisamurkowski",
    "State": "AK"
  },
  {
    "FirstName": "Dan",
    "LastName": "Sullivan",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-3004",
    "Address": "SH-706",
    "WebsiteURL": "https://www.sullivan.senate.gov",
    "FacebookURL": "https://facebook.com/SenDanSullivan",
    "XURL": "https://x.com/SenDanSullivan",
    "State": "AK"
  },
  {
    "FirstName": "Katie Boyd",
    "LastName": "Britt",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5744",
    "Address": "SR-416",
    "WebsiteURL": "https://www.britt.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorMarkKelly",
    "XURL": "https://x.com/SenMarkKelly",
    "State": "AL"
  },
  {
    "FirstName": "Tommy",
    "LastName": "Tuberville",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-4124",
    "Address": "SR-455",
    "WebsiteURL": "https://www.tuberville.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorGallego",
    "XURL": "https://x.com/SenRubenGallego",
    "State": "AL"
  },
  {
    "FirstName": "Ruben",
    "LastName": "Gallego",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4521",
    "Address": "SH-302",
    "WebsiteURL": "https://www.gallego.senate.gov",
    "FacebookURL": "https://facebook.com/JohnBoozman",
    "XURL": "https://x.com/JohnBoozman",
    "State": "AZ"
  },
  {
    "FirstName": "Mark",
    "LastName": "Kelly",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2235",
    "Address": "SH-516",
    "WebsiteURL": "https://www.kelly.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorTomCotton",
    "XURL": "https://x.com/SenTomCotton",
    "State": "AZ"
  },
  {
    "FirstName": "Alex",
    "LastName": "Padilla",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3553",
    "Address": "SH-331",
    "WebsiteURL": "https://www.padilla.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorAlexPadilla",
    "XURL": "https://x.com/SenAlexPadilla",
    "State": "CA"
  },
  {
    "FirstName": "Adam B.",
    "LastName": "Schiff",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3841",
    "Address": "SH-112",
    "WebsiteURL": "https://www.schiff.senate.gov",
    "FacebookURL": "https://facebook.com/AdamSchiff",
    "XURL": "https://x.com/SenAdamSchiff",
    "State": "CA"
  },
  {
    "FirstName": "Michael F.",
    "LastName": "Bennet",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-5852",
    "Address": "SR-261",
    "WebsiteURL": "https://www.bennet.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorBennet",
    "XURL": "https://x.com/SenatorBennet",
    "State": "CO"
  },
  {
    "FirstName": "John W.",
    "LastName": "Hickenlooper",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-5941",
    "Address": "SH-316",
    "WebsiteURL": "https://www.hickenlooper.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorHick",
    "XURL": "https://x.com/SenatorHick",
    "State": "CO"
  },
  {
    "FirstName": "Richard",
    "LastName": "Blumenthal",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2823",
    "Address": "SH-503",
    "WebsiteURL": "https://www.blumenthal.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorBlumenthal",
    "XURL": "https://x.com/SenBlumenthal",
    "State": "CT"
  },
  {
    "FirstName": "Christopher",
    "LastName": "Murphy",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4041",
    "Address": "SH-136",
    "WebsiteURL": "https://www.murphy.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorChrisMurphy",
    "XURL": "https://x.com/SenMurphyOffice",
    "State": "CT"
  },
  {
    "FirstName": "Lisa",
    "LastName": "Blunt Rochester",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2441",
    "Address": "SH-513",
    "WebsiteURL": "https://www.bluntrochester.senate.gov",
    "FacebookURL": "https://facebook.com/senatorchriscoons",
    "XURL": "https://x.com/ChrisCoons",
    "State": "DE"
  },
  {
    "FirstName": "Christopher A.",
    "LastName": "Coons",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-5042",
    "Address": "SR-218",
    "WebsiteURL": "https://www.coons.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorLBR",
    "XURL": "https://x.com/SenatorLBR",
    "State": "DE"
  },
  {
    "FirstName": "Ashley",
    "LastName": "Moody",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-3041",
    "Address": "SR-387",
    "WebsiteURL": "https://www.moody.senate.gov",
    "FacebookURL": "https://facebook.com/ashleymoodyfl",
    "XURL": "https://x.com/AshleyMoodyFL",
    "State": "FL"
  },
  {
    "FirstName": "Rick",
    "LastName": "Scott",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5274",
    "Address": "SH-110",
    "WebsiteURL": "https://www.rickscott.senate.gov",
    "FacebookURL": "https://facebook.com/RickScottSenator",
    "XURL": "https://x.com/SenRickScott",
    "State": "FL"
  },
  {
    "FirstName": "Jon",
    "LastName": "Ossoff",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3521",
    "Address": "SH-317",
    "WebsiteURL": "https://www.ossoff.senate.gov",
    "FacebookURL": "https://facebook.com/jonossoff",
    "XURL": "https://x.com/SenOssoff",
    "State": "GA"
  },
  {
    "FirstName": "Raphael G.",
    "LastName": "Warnock",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3643",
    "Address": "SH-717",
    "WebsiteURL": "https://www.warnock.senate.gov",
    "FacebookURL": "https://facebook.com/reverendwarnock",
    "XURL": "https://x.com/SenatorWarnock",
    "State": "GA"
  },
  {
    "FirstName": "Mazie K.",
    "LastName": "Hirono",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-6361",
    "Address": "SH-109",
    "WebsiteURL": "https://www.hirono.senate.gov",
    "FacebookURL": "https://facebook.com/msmaziehirono",
    "XURL": "https://x.com/maziehirono",
    "State": "HA"
  },
  {
    "FirstName": "Brian",
    "LastName": "Schatz",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3934",
    "Address": "SH-722",
    "WebsiteURL": "https://www.schatz.senate.gov",
    "FacebookURL": "https://facebook.com/senatorbrianschatz",
    "XURL": "https://x.com/SenBrianSchatz",
    "State": "HA"
  },
  {
    "FirstName": "Joni",
    "LastName": "Ernst",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-3254",
    "Address": "SR-260",
    "WebsiteURL": "https://www.ernst.senate.gov",
    "FacebookURL": "https://facebook.com/mikecrapo",
    "XURL": "https://x.com/mikecrapo",
    "State": "IA"
  },
  {
    "FirstName": "Chuck",
    "LastName": "Grassley",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-3744",
    "Address": "SH-135",
    "WebsiteURL": "https://www.grassley.senate.gov",
    "FacebookURL": "https://facebook.com/senatorrisch",
    "XURL": "https://x.com/SenatorRisch",
    "State": "IA"
  },
  {
    "FirstName": "Mike",
    "LastName": "Crapo",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6142",
    "Address": "SD-239",
    "WebsiteURL": "https://www.crapo.senate.gov",
    "FacebookURL": "https://facebook.com/SenDuckworth",
    "XURL": "https://x.com/SenDuckworth",
    "State": "ID"
  },
  {
    "FirstName": "James E.",
    "LastName": "Risch",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2752",
    "Address": "SR-483",
    "WebsiteURL": "https://www.risch.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorDurbin",
    "XURL": "https://x.com/SenatorDurbin",
    "State": "ID"
  },
  {
    "FirstName": "Tammy",
    "LastName": "Duckworth",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2854",
    "Address": "SH-524",
    "WebsiteURL": "https://www.duckworth.senate.gov",
    "FacebookURL": "https://facebook.com/RepJimBanks",
    "XURL": "https://x.com/Jim_Banks",
    "State": "IL"
  },
  {
    "FirstName": "Richard J.",
    "LastName": "Durbin",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2152",
    "Address": "SH-711",
    "WebsiteURL": "https://www.durbin.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorToddYoung",
    "XURL": "https://x.com/SenToddYoung",
    "State": "IL"
  },
  {
    "FirstName": "Jim",
    "LastName": "Banks",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-4814",
    "Address": "SH-303",
    "WebsiteURL": "https://www.banks.senate.gov",
    "FacebookURL": "https://facebook.com/senjoniernst",
    "XURL": "https://x.com/SenJoniErnst",
    "State": "IN"
  },
  {
    "FirstName": "Todd",
    "LastName": "Young",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5623",
    "Address": "SD-185",
    "WebsiteURL": "https://www.young.senate.gov",
    "FacebookURL": "https://facebook.com/chuckgrassley",
    "XURL": "https://x.com/ChuckGrassley",
    "State": "IN"
  },
  {
    "FirstName": "Roger",
    "LastName": "Marshall",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-4774",
    "Address": "SR-479A",
    "WebsiteURL": "https://www.marshall.senate.gov",
    "FacebookURL": "https://facebook.com/RogerMarshallMD",
    "XURL": "https://x.com/RogerMarshallMD",
    "State": "KS"
  },
  {
    "FirstName": "Jerry",
    "LastName": "Moran",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6521",
    "Address": "SD-521",
    "WebsiteURL": "https://www.moran.senate.gov",
    "FacebookURL": "https://facebook.com/jerrymoran",
    "XURL": "https://x.com/JerryMoran",
    "State": "KS"
  },
  {
    "FirstName": "Mitch",
    "LastName": "McConnell",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2541",
    "Address": "SR-317",
    "WebsiteURL": "https://www.mcconnell.senate.gov",
    "FacebookURL": "https://facebook.com/mitchmcconnell",
    "XURL": "https://x.com/McConnellPress",
    "State": "KY"
  },
  {
    "FirstName": "Rand",
    "LastName": "Paul",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-4343",
    "Address": "SR-295",
    "WebsiteURL": "https://www.paul.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorRandPaul",
    "XURL": "https://x.com/SenRandPaul",
    "State": "KY"
  },
  {
    "FirstName": "Bill",
    "LastName": "Cassidy",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5824",
    "Address": "SD-455",
    "WebsiteURL": "https://www.cassidy.senate.gov",
    "FacebookURL": "https://facebook.com/billcassidy",
    "XURL": "https://x.com/BillCassidy",
    "State": "LA"
  },
  {
    "FirstName": "John",
    "LastName": "Kennedy",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-4623",
    "Address": "SR-437",
    "WebsiteURL": "https://www.kennedy.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorJohnKennedy",
    "XURL": "https://x.com/SenJohnKennedy",
    "State": "LA"
  },
  {
    "FirstName": "Angela D.",
    "LastName": "Alsobrooks",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4524",
    "Address": "SR-374",
    "WebsiteURL": "https://alsobrooks.senate.gov",
    "FacebookURL": "https://facebook.com/susancollins",
    "XURL": "https://x.com/SenatorCollins",
    "State": "MA"
  },
  {
    "FirstName": "Edward J.",
    "LastName": "Markey",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2742",
    "Address": "SD-255",
    "WebsiteURL": "https://www.markey.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorAngusSKing",
    "XURL": "https://x.com/SenAngusKing",
    "State": "MA"
  },
  {
    "FirstName": "Chris",
    "LastName": "Van Hollen",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4654",
    "Address": "SH-730",
    "WebsiteURL": "https://www.vanhollen.senate.gov",
    "FacebookURL": "https://facebook.com/AngelaAlsobrooks",
    "XURL": "https://x.com/AlsobrooksMD",
    "State": "MA"
  },
  {
    "FirstName": "Elizabeth",
    "LastName": "Warren",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4543",
    "Address": "SH-311",
    "WebsiteURL": "https://www.warren.senate.gov",
    "FacebookURL": "https://facebook.com/chrisvanhollen",
    "XURL": "https://x.com/ChrisVanHollen",
    "State": "MA"
  },
  {
    "FirstName": "Susan M.",
    "LastName": "Collins",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2523",
    "Address": "SD-413",
    "WebsiteURL": "https://www.collins.senate.gov",
    "FacebookURL": "https://facebook.com/EdJMarkey",
    "XURL": "https://x.com/SenMarkey",
    "State": "ME"
  },
  {
    "FirstName": "Angus S.",
    "LastName": "King",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Independent",
    "Phone": "202-224-5344",
    "Address": "SH-133",
    "WebsiteURL": "https://www.king.senate.gov",
    "FacebookURL": "https://facebook.com/senatorelizabethwarren",
    "XURL": "https://x.com/SenWarren",
    "State": "ME"
  },
  {
    "FirstName": "Gary C.",
    "LastName": "Peters",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-6221",
    "Address": "SH-724",
    "WebsiteURL": "https://www.peters.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorGaryPeters",
    "XURL": "https://x.com/SenGaryPeters",
    "State": "MI"
  },
  {
    "FirstName": "Elissa",
    "LastName": "Slotkin",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4822",
    "Address": "SR-291",
    "WebsiteURL": "https://www.slotkin.senate.gov",
    "FacebookURL": "https://facebook.com/RepElissaSlotkin",
    "XURL": "https://x.com/ElissaSlotkin",
    "State": "MI"
  },
  {
    "FirstName": "Steve",
    "LastName": "Daines",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2651",
    "Address": "SH-320",
    "WebsiteURL": "https://www.daines.senate.gov",
    "FacebookURL": "https://facebook.com/amyklobuchar",
    "XURL": "https://x.com/SenAmyKlobuchar",
    "State": "MN"
  },
  {
    "FirstName": "Amy",
    "LastName": "Klobuchar",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3244",
    "Address": "SD-425",
    "WebsiteURL": "https://www.klobuchar.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorTinaSmith",
    "XURL": "https://x.com/SenTinaSmith",
    "State": "MN"
  },
  {
    "FirstName": "Tina",
    "LastName": "Smith",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-5641",
    "Address": "SH-720",
    "WebsiteURL": "https://www.smith.senate.gov",
    "FacebookURL": "https://facebook.com/senatorhyde-smith",
    "XURL": "https://x.com/SenHydeSmith",
    "State": "MN"
  },
  {
    "FirstName": "Josh",
    "LastName": "Hawley",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6154",
    "Address": "SR-381",
    "WebsiteURL": "https://www.hawley.senate.gov",
    "FacebookURL": "https://facebook.com/rogerwicker",
    "XURL": "https://x.com/SenatorWicker",
    "State": "MO"
  },
  {
    "FirstName": "Eric",
    "LastName": "Schmitt",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5721",
    "Address": "SR-404",
    "WebsiteURL": "https://www.schmitt.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorJoshHawley",
    "XURL": "https://x.com/SenJoshHawley",
    "State": "MO"
  },
  {
    "FirstName": "Cindy",
    "LastName": "Hyde-Smith",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5054",
    "Address": "SH-528",
    "WebsiteURL": "https://www.hydesmith.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorEricSchmitt",
    "XURL": "https://x.com/SenEricSchmitt",
    "State": "MS"
  },
  {
    "FirstName": "Roger F.",
    "LastName": "Wicker",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6253",
    "Address": "SR-425",
    "WebsiteURL": "https://www.wicker.senate.gov",
    "FacebookURL": "https://facebook.com/SteveDainesMT",
    "XURL": "https://x.com/SteveDaines",
    "State": "MS"
  },
  {
    "FirstName": "Tim",
    "LastName": "Sheehy",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2644",
    "Address": "SR-124",
    "WebsiteURL": "https://www.sheehy.senate.gov",
    "FacebookURL": "https://facebook.com/TimSheehyMT",
    "XURL": "https://x.com/TimSheehyMT",
    "State": "MT"
  },
  {
    "FirstName": "Ted",
    "LastName": "Budd",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-3154",
    "Address": "SR-354",
    "WebsiteURL": "https://www.budd.senate.gov",
    "FacebookURL": "https://facebook.com/senatordebfischer",
    "XURL": "https://x.com/SenatorFischer",
    "State": "NC"
  },
  {
    "FirstName": "Thom",
    "LastName": "Tillis",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6342",
    "Address": "SD-113",
    "WebsiteURL": "https://www.tillis.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorRicketts",
    "XURL": "https://x.com/SenatorRicketts",
    "State": "NC"
  },
  {
    "FirstName": "Kevin",
    "LastName": "Cramer",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2043",
    "Address": "SH-313",
    "WebsiteURL": "https://www.cramer.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorCortezMasto",
    "XURL": "https://x.com/SenCortezMasto",
    "State": "ND"
  },
  {
    "FirstName": "John",
    "LastName": "Hoeven",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2551",
    "Address": "SR-338",
    "WebsiteURL": "https://www.hoeven.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorJackyRosen",
    "XURL": "https://x.com/SenJackyRosen",
    "State": "ND"
  },
  {
    "FirstName": "Deb",
    "LastName": "Fischer",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6551",
    "Address": "SR-448",
    "WebsiteURL": "https://www.fischer.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorMaggieHassan",
    "XURL": "https://x.com/SenatorHassan",
    "State": "NE"
  },
  {
    "FirstName": "Pete",
    "LastName": "Ricketts",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-4224",
    "Address": "SR-139",
    "WebsiteURL": "https://www.ricketts.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorShaheen",
    "XURL": "https://x.com/SenatorShaheen",
    "State": "NE"
  },
  {
    "FirstName": "Margaret Wood",
    "LastName": "Hassan",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3324",
    "Address": "SH-324",
    "WebsiteURL": "https://www.hassan.senate.gov",
    "FacebookURL": "https://facebook.com/corybooker",
    "XURL": "https://x.com/SenBooker",
    "State": "NH"
  },
  {
    "FirstName": "Jeanne",
    "LastName": "Shaheen",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2841",
    "Address": "SH-506",
    "WebsiteURL": "https://www.shaheen.senate.gov",
    "FacebookURL": "https://facebook.com/RepAndrewKim",
    "XURL": "https://x.com/AndrewKimNJ",
    "State": "NH"
  },
  {
    "FirstName": "Cory A.",
    "LastName": "Booker",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3224",
    "Address": "SH-306",
    "WebsiteURL": "https://www.booker.senate.gov",
    "FacebookURL": "https://facebook.com/senatorheinrich",
    "XURL": "https://x.com/MartinHeinrich",
    "State": "NJ"
  },
  {
    "FirstName": "Andy",
    "LastName": "Kim",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4744",
    "Address": "SH-520",
    "WebsiteURL": "https://www.kim.senate.gov",
    "FacebookURL": "https://facebook.com/senatorbenraylujan",
    "XURL": "https://x.com/SenatorLujan",
    "State": "NJ"
  },
  {
    "FirstName": "Martin",
    "LastName": "Heinrich",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-5521",
    "Address": "SH-709",
    "WebsiteURL": "https://www.heinrich.senate.gov",
    "FacebookURL": "https://facebook.com/senatorkirstengillibrand",
    "XURL": "https://x.com/SenGillibrand",
    "State": "NM"
  },
  {
    "FirstName": "Ben Ray",
    "LastName": "Luján",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-6621",
    "Address": "SR-498",
    "WebsiteURL": "https://www.lujan.senate.gov",
    "FacebookURL": "https://facebook.com/chuckschumer",
    "XURL": "https://x.com/SenSchumer",
    "State": "NM"
  },
  {
    "FirstName": "Catherine",
    "LastName": "Cortez Masto",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3542",
    "Address": "SH-309",
    "WebsiteURL": "https://www.cortezmasto.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorTedBudd",
    "XURL": "https://x.com/SenTedBuddNC",
    "State": "NV"
  },
  {
    "FirstName": "Jacky",
    "LastName": "Rosen",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-6244",
    "Address": "SH-713",
    "WebsiteURL": "https://www.rosen.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorThomTillis",
    "XURL": "https://x.com/SenThomTillis",
    "State": "NV"
  },
  {
    "FirstName": "Kirsten E.",
    "LastName": "Gillibrand",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4451",
    "Address": "SR-478",
    "WebsiteURL": "https://www.gillibrand.senate.gov",
    "FacebookURL": "https://facebook.com/senatorkevincramer",
    "XURL": "https://x.com/SenKevinCramer",
    "State": "NY"
  },
  {
    "FirstName": "Charles E.",
    "LastName": "Schumer",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-6542",
    "Address": "SH-322",
    "WebsiteURL": "https://www.schumer.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorJohnHoeven",
    "XURL": "https://x.com/SenJohnHoeven",
    "State": "NY"
  },
  {
    "FirstName": "Jon",
    "LastName": "Husted",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-3353",
    "Address": "SR-304",
    "WebsiteURL": "https://www.husted.senate.gov",
    "FacebookURL": "https://facebook.com/JonHusted",
    "XURL": "https://x.com/JonHusted",
    "State": "OH"
  },
  {
    "FirstName": "Bernie",
    "LastName": "Moreno",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2315",
    "Address": "SR-284",
    "WebsiteURL": "https://www.moreno.senate.gov",
    "FacebookURL": "https://facebook.com/berniemoreno",
    "XURL": "https://x.com/berniemoreno",
    "State": "OH"
  },
  {
    "FirstName": "James",
    "LastName": "Lankford",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5754",
    "Address": "SH-731",
    "WebsiteURL": "https://www.lankford.senate.gov",
    "FacebookURL": "https://facebook.com/jameslankford",
    "XURL": "https://x.com/SenatorLankford",
    "State": "OK"
  },
  {
    "FirstName": "Markwayne",
    "LastName": "Mullin",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-4721",
    "Address": "SH-330",
    "WebsiteURL": "https://www.mullin.senate.gov",
    "FacebookURL": "https://facebook.com/SenMullin",
    "XURL": "https://x.com/SenMullin",
    "State": "OK"
  },
  {
    "FirstName": "Jeff",
    "LastName": "Merkley",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3753",
    "Address": "SH-531",
    "WebsiteURL": "https://www.merkley.senate.gov",
    "FacebookURL": "https://facebook.com/jeffmerkley",
    "XURL": "https://x.com/SenJeffMerkley",
    "State": "OR"
  },
  {
    "FirstName": "Ron",
    "LastName": "Wyden",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-5244",
    "Address": "SD-221",
    "WebsiteURL": "https://www.wyden.senate.gov",
    "FacebookURL": "https://facebook.com/senatorronwyden",
    "XURL": "https://x.com/RonWyden",
    "State": "OR"
  },
  {
    "FirstName": "John",
    "LastName": "Fetterman",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4254",
    "Address": "SR-142",
    "WebsiteURL": "https://www.fetterman.senate.gov",
    "FacebookURL": "https://facebook.com/senfettermanpa",
    "XURL": "https://x.com/SenFettermanPA",
    "State": "PA"
  },
  {
    "FirstName": "David",
    "LastName": "McCormick",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6324",
    "Address": "SH-702",
    "WebsiteURL": "https://mccormick.senate.gov",
    "FacebookURL": "https://facebook.com/DaveMcCormickPA",
    "XURL": "https://x.com/DaveMcCormickPA",
    "State": "PA"
  },
  {
    "FirstName": "Jack",
    "LastName": "Reed",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4642",
    "Address": "SH-728",
    "WebsiteURL": "https://www.reed.senate.gov",
    "FacebookURL": "https://facebook.com/senatorjackreed",
    "XURL": "https://x.com/SenJackReed",
    "State": "RI"
  },
  {
    "FirstName": "Sheldon",
    "LastName": "Whitehouse",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2921",
    "Address": "SH-530",
    "WebsiteURL": "https://www.whitehouse.senate.gov",
    "FacebookURL": "https://facebook.com/senatorsheldonwhitehouse",
    "XURL": "https://x.com/SenWhitehouse",
    "State": "RI"
  },
  {
    "FirstName": "Lindsey",
    "LastName": "Graham",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5972",
    "Address": "SR-211",
    "WebsiteURL": "https://www.lgraham.senate.gov",
    "FacebookURL": "https://facebook.com/lindseygrahamsc",
    "XURL": "https://x.com/LindseyGrahamSC",
    "State": "SC"
  },
  {
    "FirstName": "Tim",
    "LastName": "Scott",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6121",
    "Address": "SH-104",
    "WebsiteURL": "https://www.scott.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorTimScott",
    "XURL": "https://x.com/SenatorTimScott",
    "State": "SC"
  },
  {
    "FirstName": "Mike",
    "LastName": "Rounds",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5842",
    "Address": "SH-716",
    "WebsiteURL": "https://www.rounds.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorMikeRounds",
    "XURL": "https://x.com/SenatorRounds",
    "State": "SD"
  },
  {
    "FirstName": "John",
    "LastName": "Thune",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2321",
    "Address": "SD-511",
    "WebsiteURL": "https://www.thune.senate.gov",
    "FacebookURL": "https://facebook.com/senatorjohnthune",
    "XURL": "https://x.com/SenJohnThune",
    "State": "SD"
  },
  {
    "FirstName": "Marsha",
    "LastName": "Blackburn",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-3344",
    "Address": "SD-357",
    "WebsiteURL": "https://www.blackburn.senate.gov",
    "FacebookURL": "https://facebook.com/marshablackburn",
    "XURL": "https://x.com/MarshaBlackburn",
    "State": "TN"
  },
  {
    "FirstName": "Bill",
    "LastName": "Hagerty",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-4944",
    "Address": "SR-251",
    "WebsiteURL": "https://www.hagerty.senate.gov",
    "FacebookURL": "https://facebook.com/senatorhagerty",
    "XURL": "https://x.com/SenatorHagerty",
    "State": "TN"
  },
  {
    "FirstName": "John",
    "LastName": "Cornyn",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-2934",
    "Address": "SH-517",
    "WebsiteURL": "https://www.cornyn.senate.gov",
    "FacebookURL": "https://facebook.com/senatorjohncornyn",
    "XURL": "https://x.com/JohnCornyn",
    "State": "TX"
  },
  {
    "FirstName": "Ted",
    "LastName": "Cruz",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5922",
    "Address": "SR-167",
    "WebsiteURL": "https://www.cruz.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorTedCruz",
    "XURL": "https://x.com/SenTedCruz",
    "State": "TX"
  },
  {
    "FirstName": "John R.",
    "LastName": "Curtis",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5251",
    "Address": "SH-502",
    "WebsiteURL": "https://www.curtis.senate.gov",
    "FacebookURL": "https://facebook.com/RepJohnCurtis",
    "XURL": "https://x.com/RepJohnCurtis",
    "State": "UT"
  },
  {
    "FirstName": "Mike",
    "LastName": "Lee",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5444",
    "Address": "SR-363",
    "WebsiteURL": "https://www.lee.senate.gov",
    "FacebookURL": "https://facebook.com/senatormikelee",
    "XURL": "https://x.com/SenMikeLee",
    "State": "UT"
  },
  {
    "FirstName": "Tim",
    "LastName": "Kaine",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4024",
    "Address": "SR-231",
    "WebsiteURL": "https://www.kaine.senate.gov",
    "FacebookURL": "https://facebook.com/senatorsanders",
    "XURL": "https://x.com/SenSanders",
    "State": "VA"
  },
  {
    "FirstName": "Mark R.",
    "LastName": "Warner",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2023",
    "Address": "SH-703",
    "WebsiteURL": "https://www.warner.senate.gov",
    "FacebookURL": "https://facebook.com/SenatorPeterWelch",
    "XURL": "https://x.com/SenPeterWelch",
    "State": "VA"
  },
  {
    "FirstName": "Bernard",
    "LastName": "Sanders",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Independent",
    "Phone": "202-224-5141",
    "Address": "SD-332",
    "WebsiteURL": "https://www.sanders.senate.gov",
    "FacebookURL": "https://facebook.com/senatortimkaine",
    "XURL": "https://x.com/timkaine",
    "State": "VT"
  },
  {
    "FirstName": "Peter",
    "LastName": "Welch",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-4242",
    "Address": "SR-115",
    "WebsiteURL": "https://www.welch.senate.gov",
    "FacebookURL": "https://facebook.com/senatormarkwarner",
    "XURL": "https://x.com/MarkWarner",
    "State": "VT"
  },
  {
    "FirstName": "Maria",
    "LastName": "Cantwell",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-3441",
    "Address": "SH-511",
    "WebsiteURL": "https://www.cantwell.senate.gov",
    "FacebookURL": "https://facebook.com/senatormariacantwell",
    "XURL": "https://x.com/SenatorCantwell",
    "State": "WA"
  },
  {
    "FirstName": "Patty",
    "LastName": "Murray",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-2621",
    "Address": "SR-154",
    "WebsiteURL": "https://www.murray.senate.gov",
    "FacebookURL": "https://facebook.com/pattymurray",
    "XURL": "https://x.com/pattymurray",
    "State": "WA"
  },
  {
    "FirstName": "Tammy",
    "LastName": "Baldwin",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Democratic",
    "Phone": "202-224-5653",
    "Address": "SH-141",
    "WebsiteURL": "https://www.baldwin.senate.gov",
    "FacebookURL": "https://facebook.com/senshelley",
    "XURL": "https://x.com/SenCapito",
    "State": "WI"
  },
  {
    "FirstName": "Ron",
    "LastName": "Johnson",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-5323",
    "Address": "SH-328",
    "WebsiteURL": "https://www.ronjohnson.senate.gov",
    "FacebookURL": "https://facebook.com/GovJustice",
    "XURL": "https://x.com/JimJusticeWV",
    "State": "WI"
  },
  {
    "FirstName": "Shelley Moore",
    "LastName": "Capito",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6472",
    "Address": "SR-170",
    "WebsiteURL": "https://www.capito.senate.gov",
    "FacebookURL": "https://facebook.com/senatortammybaldwin",
    "XURL": "https://x.com/SenatorBaldwin",
    "State": "WV"
  },
  {
    "FirstName": "James C.",
    "LastName": "Justice",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-3954",
    "Address": "SH-509",
    "WebsiteURL": "https://www.justice.senate.gov",
    "FacebookURL": "https://facebook.com/senronjohnson",
    "XURL": "https://x.com/SenRonJohnson",
    "State": "WV"
  },
  {
    "FirstName": "John",
    "LastName": "Barrasso",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-6441",
    "Address": "SD-307",
    "WebsiteURL": "https://www.barrasso.senate.gov",
    "FacebookURL": "https://facebook.com/johnbarrasso",
    "XURL": "https://x.com/SenJohnBarrasso",
    "State": "WY"
  },
  {
    "FirstName": "Cynthia M.",
    "LastName": "Lummis",
    "Role": "Senator",
    "Division": "Federal",
    "Party": "Republican",
    "Phone": "202-224-3424",
    "Address": "SR-127A",
    "WebsiteURL": "https://www.lummis.senate.gov",
    "FacebookURL": "https://facebook.com/CynthiaLummis",
    "XURL": "https://x.com/SenLummis",
    "State": "WY"
  },
  {
    "FirstName": "Nicholas",
    "LastName": "Begich",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5765",
    "Address": "153 CHOB",
    "WebsiteURL": "https://begich.house.gov",
    "FacebookURL": "",
    "XURL": "",
    "State": "AK"
  },
  {
    "FirstName": "Barry",
    "LastName": "Moore",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2901",
    "Address": "1511 LHOB",
    "WebsiteURL": "https://barrymoore.house.gov",
    "FacebookURL": "",
    "XURL": "",
    "State": "AL"
  },
  {
    "FirstName": "Shomari",
    "LastName": "Figures",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4931",
    "Address": "225 CHOB",
    "WebsiteURL": "https://figures.house.gov",
    "FacebookURL": "https://facebook.com/figuresforcongress",
    "XURL": "https://x.com/FiguresForAL02",
    "State": "AL"
  },
  {
    "FirstName": "Mike",
    "LastName": "Rogers",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3261",
    "Address": "2469 RHOB",
    "WebsiteURL": "https://mikerogers.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeRogersAL",
    "XURL": "https://x.com/RepMikeRogersAL",
    "State": "AL"
  },
  {
    "FirstName": "Robert",
    "LastName": "Aderholt",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4876",
    "Address": "272 CHOB",
    "WebsiteURL": "https://aderholt.house.gov",
    "FacebookURL": "https://facebook.com/RobertAderholt",
    "XURL": "https://x.com/Robert_Aderholt",
    "State": "AL"
  },
  {
    "FirstName": "Dale",
    "LastName": "Strong",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4801",
    "Address": "449 CHOB",
    "WebsiteURL": "https://strong.house.gov",
    "FacebookURL": "https://facebook.com/RepDaleStrong",
    "XURL": "https://x.com/RepDaleStrong",
    "State": "AL"
  },
  {
    "FirstName": "Gary",
    "LastName": "Palmer",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4921",
    "Address": "170 CHOB",
    "WebsiteURL": "https://palmer.house.gov",
    "FacebookURL": "https://facebook.com/RepGaryPalmer",
    "XURL": "https://x.com/USRepGaryPalmer",
    "State": "AL"
  },
  {
    "FirstName": "Terri",
    "LastName": "Sewell",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2665",
    "Address": "1035 LHOB",
    "WebsiteURL": "https://sewell.house.gov",
    "FacebookURL": "https://facebook.com/RepTerriSewell",
    "XURL": "https://x.com/RepTerriSewell",
    "State": "AL"
  },
  {
    "FirstName": "Aumua Amata",
    "LastName": "Radewagen",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-8577",
    "Address": "2001 RHOB",
    "WebsiteURL": "https://radewagen.house.gov",
    "FacebookURL": "https://facebook.com/NickBegich",
    "XURL": "https://x.com/NickBegich",
    "State": "AS"
  },
  {
    "FirstName": "David",
    "LastName": "Schweikert",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2190",
    "Address": "166 CHOB",
    "WebsiteURL": "https://schweikert.house.gov",
    "FacebookURL": "https://facebook.com/RepDavid",
    "XURL": "https://x.com/RepDavid",
    "State": "AZ"
  },
  {
    "FirstName": "Elijah",
    "LastName": "Crane",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3361",
    "Address": "307 CHOB",
    "WebsiteURL": "https://crane.house.gov",
    "FacebookURL": "https://facebook.com/RepEliCrane",
    "XURL": "https://x.com/RepEliCrane",
    "State": "AZ"
  },
  {
    "FirstName": "Yassamin",
    "LastName": "Ansari",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4065",
    "Address": "1432 LHOB",
    "WebsiteURL": "https://ansari.house.gov",
    "FacebookURL": "https://facebook.com/YassaminAnsari",
    "XURL": "https://x.com/yassaminansari",
    "State": "AZ"
  },
  {
    "FirstName": "Greg",
    "LastName": "Stanton",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-9888",
    "Address": "207 CHOB",
    "WebsiteURL": "https://stanton.house.gov",
    "FacebookURL": "https://facebook.com/RepGregStanton",
    "XURL": "https://x.com/RepGregStanton",
    "State": "AZ"
  },
  {
    "FirstName": "Andy",
    "LastName": "Biggs",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2635",
    "Address": "464 CHOB",
    "WebsiteURL": "https://biggs.house.gov",
    "FacebookURL": "https://facebook.com/RepAndyBiggs",
    "XURL": "https://x.com/RepAndyBiggsAZ",
    "State": "AZ"
  },
  {
    "FirstName": "Juan",
    "LastName": "Ciscomani",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2542",
    "Address": "461 CHOB",
    "WebsiteURL": "https://ciscomani.house.gov",
    "FacebookURL": "https://facebook.com/RepJuanCiscomani",
    "XURL": "https://x.com/RepCiscomani",
    "State": "AZ"
  },
  {
    "FirstName": "Raúl M.- Vacancy",
    "LastName": "Grijalva",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2435",
    "Address": "1203 LHOB",
    "WebsiteURL": "https://clerk.house.govmembers/AZ07/vacancy",
    "FacebookURL": "https://facebook.com/RepRaulGrijalva",
    "XURL": "https://x.com/RepRaulGrijalva",
    "State": "AZ"
  },
  {
    "FirstName": "Abraham",
    "LastName": "Hamadeh",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4576",
    "Address": "1722 LHOB",
    "WebsiteURL": "https://hamadeh.house.gov",
    "FacebookURL": "https://facebook.com/AbrahamHamadeh",
    "XURL": "https://x.com/AbrahamHamadeh",
    "State": "AZ"
  },
  {
    "FirstName": "Paul",
    "LastName": "Gosar",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2315",
    "Address": "2057 RHOB",
    "WebsiteURL": "https://gosar.house.gov",
    "FacebookURL": "https://facebook.com/RepGosar",
    "XURL": "https://x.com/RepGosar",
    "State": "AZ"
  },
  {
    "FirstName": "Eric",
    "LastName": "Crawford",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4076",
    "Address": "2422 RHOB",
    "WebsiteURL": "https://crawford.house.gov",
    "FacebookURL": "https://facebook.com/RepRickCrawford",
    "XURL": "https://x.com/RepRickCrawford",
    "State": "AR"
  },
  {
    "FirstName": "J.",
    "LastName": "Hill",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2506",
    "Address": "1533 LHOB",
    "WebsiteURL": "https://hill.house.gov",
    "FacebookURL": "https://facebook.com/RepFrenchHill",
    "XURL": "https://x.com/RepFrenchHill",
    "State": "AR"
  },
  {
    "FirstName": "Steve",
    "LastName": "Womack",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4301",
    "Address": "2412 RHOB",
    "WebsiteURL": "https://womack.house.gov",
    "FacebookURL": "https://facebook.com/RepSteveWomack",
    "XURL": "https://x.com/rep_steve_womack",
    "State": "AR"
  },
  {
    "FirstName": "Bruce",
    "LastName": "Westerman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3772",
    "Address": "202 CHOB",
    "WebsiteURL": "https://westerman.house.gov",
    "FacebookURL": "https://facebook.com/RepWesterman",
    "XURL": "https://x.com/RepWesterman",
    "State": "AR"
  },
  {
    "FirstName": "Doug",
    "LastName": "LaMalfa",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3076",
    "Address": "408 CHOB",
    "WebsiteURL": "https://lamalfa.house.gov",
    "FacebookURL": "https://facebook.com/RepLaMalfa",
    "XURL": "https://x.com/RepLaMalfa",
    "State": "CA"
  },
  {
    "FirstName": "Jared",
    "LastName": "Huffman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5161",
    "Address": "2330 RHOB",
    "WebsiteURL": "https://huffman.house.gov",
    "FacebookURL": "https://facebook.com/RepHuffman",
    "XURL": "https://x.com/RepHuffman",
    "State": "CA"
  },
  {
    "FirstName": "Kevin",
    "LastName": "Kiley",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2523",
    "Address": "2445 RHOB",
    "WebsiteURL": "https://kiley.house.gov",
    "FacebookURL": "https://facebook.com/RepKiley",
    "XURL": "https://x.com/RepKiley",
    "State": "CA"
  },
  {
    "FirstName": "Mike",
    "LastName": "Thompson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3311",
    "Address": "268 CHOB",
    "WebsiteURL": "https://mikethompson.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeThompson",
    "XURL": "https://x.com/RepThompson",
    "State": "CA"
  },
  {
    "FirstName": "Tom",
    "LastName": "McClintock",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2511",
    "Address": "2256 RHOB",
    "WebsiteURL": "https://mcclintock.house.gov",
    "FacebookURL": "https://facebook.com/RepMcClintock",
    "XURL": "https://x.com/RepMcClintock",
    "State": "CA"
  },
  {
    "FirstName": "Ami",
    "LastName": "Bera",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5716",
    "Address": "172 CHOB",
    "WebsiteURL": "https://bera.house.gov",
    "FacebookURL": "https://facebook.com/RepAmiBera",
    "XURL": "https://x.com/RepAmiBera",
    "State": "CA"
  },
  {
    "FirstName": "Doris",
    "LastName": "Matsui",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7163",
    "Address": "2206 RHOB",
    "WebsiteURL": "https://matsui.house.gov",
    "FacebookURL": "https://facebook.com/RepDorisMatsui",
    "XURL": "https://x.com/DorisMatsui",
    "State": "CA"
  },
  {
    "FirstName": "John",
    "LastName": "Garamendi",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1880",
    "Address": "2428 RHOB",
    "WebsiteURL": "https://garamendi.house.gov",
    "FacebookURL": "https://facebook.com/RepGaramendi",
    "XURL": "https://x.com/RepGaramendi",
    "State": "CA"
  },
  {
    "FirstName": "Josh",
    "LastName": "Harder",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4540",
    "Address": "209 CHOB",
    "WebsiteURL": "https://harder.house.gov",
    "FacebookURL": "https://facebook.com/RepJoshHarder",
    "XURL": "https://x.com/RepJoshHarder",
    "State": "CA"
  },
  {
    "FirstName": "Mark",
    "LastName": "DeSaulnier",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2095",
    "Address": "2134 RHOB",
    "WebsiteURL": "https://desaulnier.house.gov",
    "FacebookURL": "https://facebook.com/RepDeSaulnier",
    "XURL": "https://x.com/RepDeSaulnier",
    "State": "CA"
  },
  {
    "FirstName": "Nancy",
    "LastName": "Pelosi",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4965",
    "Address": "1236 LHOB",
    "WebsiteURL": "https://pelosi.house.gov",
    "FacebookURL": "https://facebook.com/NancyPelosi",
    "XURL": "https://x.com/SpeakerPelosi",
    "State": "CA"
  },
  {
    "FirstName": "Lateefah",
    "LastName": "Simon",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2661",
    "Address": "1023 LHOB",
    "WebsiteURL": "https://simon.house.gov",
    "FacebookURL": "https://facebook.com/LateefahSimon",
    "XURL": "https://x.com/LateefahSimon",
    "State": "CA"
  },
  {
    "FirstName": "Adam",
    "LastName": "Gray",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1947",
    "Address": "1230 LHOB",
    "WebsiteURL": "https://gray.house.gov",
    "FacebookURL": "https://facebook.com/RepJohnDuarte",
    "XURL": "https://x.com/RepJohnDuarte",
    "State": "CA"
  },
  {
    "FirstName": "Eric",
    "LastName": "Swalwell",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5065",
    "Address": "174 CHOB",
    "WebsiteURL": "https://swalwell.house.gov",
    "FacebookURL": "https://facebook.com/RepSwalwell",
    "XURL": "https://x.com/RepSwalwell",
    "State": "CA"
  },
  {
    "FirstName": "Kevin",
    "LastName": "Mullin",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3531",
    "Address": "1404 LHOB",
    "WebsiteURL": "https://kevinmullin.house.gov",
    "FacebookURL": "https://facebook.com/RepKevinMullin",
    "XURL": "https://x.com/RepKevinMullin",
    "State": "CA"
  },
  {
    "FirstName": "Sam",
    "LastName": "Liccardo",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8104",
    "Address": "1117 LHOB",
    "WebsiteURL": "https://liccardo.house.gov",
    "FacebookURL": "https://facebook.com/samliccardo",
    "XURL": "https://x.com/samliccardo",
    "State": "CA"
  },
  {
    "FirstName": "Ro",
    "LastName": "Khanna",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2631",
    "Address": "306 CHOB",
    "WebsiteURL": "https://khanna.house.gov",
    "FacebookURL": "https://facebook.com/RepRoKhanna",
    "XURL": "https://x.com/RepRoKhanna",
    "State": "CA"
  },
  {
    "FirstName": "Zoe",
    "LastName": "Lofgren",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3072",
    "Address": "1401 LHOB",
    "WebsiteURL": "https://lofgren.house.gov",
    "FacebookURL": "https://facebook.com/RepZoeLofgren",
    "XURL": "https://x.com/RepZoeLofgren",
    "State": "CA"
  },
  {
    "FirstName": "Jimmy",
    "LastName": "Panetta",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2861",
    "Address": "200 CHOB",
    "WebsiteURL": "https://panetta.house.gov",
    "FacebookURL": "https://facebook.com/RepJimmyPanetta",
    "XURL": "https://x.com/RepPanetta",
    "State": "CA"
  },
  {
    "FirstName": "Vince",
    "LastName": "Fong",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2915",
    "Address": "243 CHOB",
    "WebsiteURL": "https://fong.house.gov",
    "FacebookURL": "https://facebook.com/vincefong",
    "XURL": "https://x.com/VinceFong",
    "State": "CA"
  },
  {
    "FirstName": "Jim",
    "LastName": "Costa",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3341",
    "Address": "2081 RHOB",
    "WebsiteURL": "https://costa.house.gov",
    "FacebookURL": "https://facebook.com/RepJimCosta",
    "XURL": "https://x.com/RepJimCosta",
    "State": "CA"
  },
  {
    "FirstName": "David",
    "LastName": "Valadao",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4695",
    "Address": "2465 RHOB",
    "WebsiteURL": "https://valadao.house.gov",
    "FacebookURL": "https://facebook.com/RepDavidValadao",
    "XURL": "https://x.com/RepValadao",
    "State": "CA"
  },
  {
    "FirstName": "Jay",
    "LastName": "Obernolte",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5861",
    "Address": "2433 RHOB",
    "WebsiteURL": "https://obernolte.house.gov",
    "FacebookURL": "https://facebook.com/RepObernolte",
    "XURL": "https://x.com/RepObernolte",
    "State": "CA"
  },
  {
    "FirstName": "Salud",
    "LastName": "Carbajal",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3601",
    "Address": "2331 RHOB",
    "WebsiteURL": "https://carbajal.house.gov",
    "FacebookURL": "https://facebook.com/RepSaludCarbajal",
    "XURL": "https://x.com/RepCarbajal",
    "State": "CA"
  },
  {
    "FirstName": "Raul",
    "LastName": "Ruiz",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5330",
    "Address": "2342 RHOB",
    "WebsiteURL": "https://ruiz.house.gov",
    "FacebookURL": "https://facebook.com/RepRaulRuizMD",
    "XURL": "https://x.com/CongressmanRuiz",
    "State": "CA"
  },
  {
    "FirstName": "Julia",
    "LastName": "Brownley",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5811",
    "Address": "2262 RHOB",
    "WebsiteURL": "https://juliabrownley.house.gov",
    "FacebookURL": "https://facebook.com/RepJuliaBrownley",
    "XURL": "https://x.com/RepBrownley",
    "State": "CA"
  },
  {
    "FirstName": "George",
    "LastName": "Whitesides",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1956",
    "Address": "1504 LHOB",
    "WebsiteURL": "https://whitesides.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeGarcia",
    "XURL": "https://x.com/RepMikeGarcia",
    "State": "CA"
  },
  {
    "FirstName": "Judy",
    "LastName": "Chu",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5464",
    "Address": "2423 RHOB",
    "WebsiteURL": "https://chu.house.gov",
    "FacebookURL": "https://facebook.com/RepJudyChu",
    "XURL": "https://x.com/RepJudyChu",
    "State": "CA"
  },
  {
    "FirstName": "Luz",
    "LastName": "Rivas",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6131",
    "Address": "1319 LHOB",
    "WebsiteURL": "https://rivas.house.gov",
    "FacebookURL": "https://facebook.com/LuzRivasforCongress",
    "XURL": "https://x.com/LuzRivas",
    "State": "CA"
  },
  {
    "FirstName": "Laura",
    "LastName": "Friedman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4176",
    "Address": "1517 LHOB",
    "WebsiteURL": "https://friedman.house.gov",
    "FacebookURL": "https://facebook.com/LauraFriedmanCA",
    "XURL": "https://x.com/LauraFriedman43",
    "State": "CA"
  },
  {
    "FirstName": "Gilbert",
    "LastName": "Cisneros",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5256",
    "Address": "2463 RHOB",
    "WebsiteURL": "https://cisneros.house.gov",
    "FacebookURL": "https://facebook.com/GilCisnerosCA",
    "XURL": "https://x.com/GilCisnerosCA",
    "State": "CA"
  },
  {
    "FirstName": "Brad",
    "LastName": "Sherman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5911",
    "Address": "2365 RHOB",
    "WebsiteURL": "https://sherman.house.gov",
    "FacebookURL": "https://facebook.com/RepBradSherman",
    "XURL": "https://x.com/BradSherman",
    "State": "CA"
  },
  {
    "FirstName": "Pete",
    "LastName": "Aguilar",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3201",
    "Address": "108 CHOB",
    "WebsiteURL": "https://aguilar.house.gov",
    "FacebookURL": "https://facebook.com/reppeteaguilar",
    "XURL": "https://x.com/RepPeteAguilar",
    "State": "CA"
  },
  {
    "FirstName": "Jimmy",
    "LastName": "Gomez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6235",
    "Address": "506 CHOB",
    "WebsiteURL": "https://gomez.house.gov",
    "FacebookURL": "https://facebook.com/RepJimmyGomez",
    "XURL": "https://x.com/RepJimmyGomez",
    "State": "CA"
  },
  {
    "FirstName": "Norma",
    "LastName": "Torres",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6161",
    "Address": "2227 RHOB",
    "WebsiteURL": "https://torres.house.gov",
    "FacebookURL": "https://facebook.com/RepNormaTorres",
    "XURL": "https://x.com/NormaJTorres",
    "State": "CA"
  },
  {
    "FirstName": "Ted",
    "LastName": "Lieu",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3976",
    "Address": "2454 RHOB",
    "WebsiteURL": "https://lieu.house.gov",
    "FacebookURL": "https://facebook.com/RepTedLieu",
    "XURL": "https://x.com/tedlieu",
    "State": "CA"
  },
  {
    "FirstName": "Sydney",
    "LastName": "Kamlager-Dove",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7084",
    "Address": "144 CHOB",
    "WebsiteURL": "https://kamlager-dove.house.gov",
    "FacebookURL": "https://facebook.com/RepKamlagerDove",
    "XURL": "https://x.com/RepKamlagerDove",
    "State": "CA"
  },
  {
    "FirstName": "Linda",
    "LastName": "Sanchez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6676",
    "Address": "2309 RHOB",
    "WebsiteURL": "https://lindasanchez.house.gov",
    "FacebookURL": "https://facebook.com/RepLindaSanchez",
    "XURL": "https://x.com/RepLindaSanchez",
    "State": "CA"
  },
  {
    "FirstName": "Mark",
    "LastName": "Takano",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2305",
    "Address": "2078 RHOB",
    "WebsiteURL": "https://takano.house.gov",
    "FacebookURL": "https://facebook.com/RepMarkTakano",
    "XURL": "https://x.com/RepMarkTakano",
    "State": "CA"
  },
  {
    "FirstName": "Young",
    "LastName": "Kim",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4111",
    "Address": "2439 RHOB",
    "WebsiteURL": "https://youngkim.house.gov",
    "FacebookURL": "https://facebook.com/RepYoungKim",
    "XURL": "https://x.com/RepYoungKim",
    "State": "CA"
  },
  {
    "FirstName": "Ken",
    "LastName": "Calvert",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-1986",
    "Address": "2205 RHOB",
    "WebsiteURL": "https://calvert.house.gov",
    "FacebookURL": "https://facebook.com/RepKenCalvert",
    "XURL": "https://x.com/KenCalvert",
    "State": "CA"
  },
  {
    "FirstName": "Robert",
    "LastName": "Garcia",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7924",
    "Address": "109 CHOB",
    "WebsiteURL": "https://robertgarcia.house.gov",
    "FacebookURL": "https://facebook.com/RepRobertGarcia",
    "XURL": "https://x.com/RepRobertGarcia",
    "State": "CA"
  },
  {
    "FirstName": "Maxine",
    "LastName": "Waters",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2201",
    "Address": "2221 RHOB",
    "WebsiteURL": "https://waters.house.gov",
    "FacebookURL": "https://facebook.com/RepMaxineWaters",
    "XURL": "https://x.com/RepMaxineWaters",
    "State": "CA"
  },
  {
    "FirstName": "Nanette",
    "LastName": "Barragan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8220",
    "Address": "2312 RHOB",
    "WebsiteURL": "https://barragan.house.gov",
    "FacebookURL": "https://facebook.com/RepBarragan",
    "XURL": "https://x.com/RepBarragan",
    "State": "CA"
  },
  {
    "FirstName": "Derek",
    "LastName": "Tran",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2415",
    "Address": "1127 LHOB",
    "WebsiteURL": "https://tran.house.gov",
    "FacebookURL": "https://facebook.com/RepSteel",
    "XURL": "https://x.com/RepSteel",
    "State": "CA"
  },
  {
    "FirstName": "J.",
    "LastName": "Correa",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2965",
    "Address": "2082 RHOB",
    "WebsiteURL": "https://correa.house.gov",
    "FacebookURL": "https://facebook.com/RepLouCorrea",
    "XURL": "https://x.com/RepLouCorrea",
    "State": "CA"
  },
  {
    "FirstName": "Dave",
    "LastName": "Min",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5611",
    "Address": "1034 LHOB",
    "WebsiteURL": "https://min.house.gov",
    "FacebookURL": "https://facebook.com/DaveMinCA",
    "XURL": "https://x.com/DaveMinCA",
    "State": "CA"
  },
  {
    "FirstName": "Darrell",
    "LastName": "Issa",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5672",
    "Address": "2108 RHOB",
    "WebsiteURL": "https://issa.house.gov",
    "FacebookURL": "https://facebook.com/RepDarrellIssa",
    "XURL": "https://x.com/repdarrellissa",
    "State": "CA"
  },
  {
    "FirstName": "Mike",
    "LastName": "Levin",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3906",
    "Address": "2352 RHOB",
    "WebsiteURL": "https://levin.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeLevin",
    "XURL": "https://x.com/RepMikeLevin",
    "State": "CA"
  },
  {
    "FirstName": "Scott",
    "LastName": "Peters",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-0508",
    "Address": "2369 RHOB",
    "WebsiteURL": "https://scottpeters.house.gov",
    "FacebookURL": "https://facebook.com/RepScottPeters",
    "XURL": "https://x.com/RepScottPeters",
    "State": "CA"
  },
  {
    "FirstName": "Sara",
    "LastName": "Jacobs",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2040",
    "Address": "2348 RHOB",
    "WebsiteURL": "https://sarajacobs.house.gov",
    "FacebookURL": "https://facebook.com/RepSaraJacobs",
    "XURL": "https://x.com/RepSaraJacobs",
    "State": "CA"
  },
  {
    "FirstName": "Juan",
    "LastName": "Vargas",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8045",
    "Address": "2467 RHOB",
    "WebsiteURL": "https://vargas.house.gov",
    "FacebookURL": "https://facebook.com/RepJuanVargas",
    "XURL": "https://x.com/RepJuanVargas",
    "State": "CA"
  },
  {
    "FirstName": "Diana",
    "LastName": "DeGette",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4431",
    "Address": "2111 RHOB",
    "WebsiteURL": "https://degette.house.gov",
    "FacebookURL": "https://facebook.com/RepDianaDeGette",
    "XURL": "https://x.com/RepDianaDeGette",
    "State": "CO"
  },
  {
    "FirstName": "Joe",
    "LastName": "Neguse",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2161",
    "Address": "2400 RHOB",
    "WebsiteURL": "https://neguse.house.gov",
    "FacebookURL": "https://facebook.com/RepJoeNeguse",
    "XURL": "https://x.com/RepJoeNeguse",
    "State": "CO"
  },
  {
    "FirstName": "Jeff",
    "LastName": "Hurd",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4676",
    "Address": "1641 LHOB",
    "WebsiteURL": "https://hurd.house.gov",
    "FacebookURL": "https://facebook.com/HurdForColorado",
    "XURL": "https://x.com/HurdForColorado",
    "State": "CO"
  },
  {
    "FirstName": "Lauren",
    "LastName": "Boebert",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4761",
    "Address": "1713 LHOB",
    "WebsiteURL": "https://boebert.house.gov",
    "FacebookURL": "https://facebook.com/RepBoebert",
    "XURL": "https://x.com/RepBoebert",
    "State": "CO"
  },
  {
    "FirstName": "Jeff",
    "LastName": "Crank",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4422",
    "Address": "1029 LHOB",
    "WebsiteURL": "https://crank.house.gov",
    "FacebookURL": "https://facebook.com/JeffCrankCO",
    "XURL": "https://x.com/JeffCrank",
    "State": "CO"
  },
  {
    "FirstName": "Jason",
    "LastName": "Crow",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7882",
    "Address": "1323 LHOB",
    "WebsiteURL": "https://crow.house.gov",
    "FacebookURL": "https://facebook.com/RepJasonCrow",
    "XURL": "https://x.com/RepJasonCrow",
    "State": "CO"
  },
  {
    "FirstName": "Brittany",
    "LastName": "Pettersen",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2645",
    "Address": "348 CHOB",
    "WebsiteURL": "https://pettersen.house.gov",
    "FacebookURL": "https://facebook.com/RepPettersen",
    "XURL": "https://x.com/RepPettersen",
    "State": "CO"
  },
  {
    "FirstName": "Gabe",
    "LastName": "Evans",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5625",
    "Address": "1229 LHOB",
    "WebsiteURL": "https://gabeevans.house.gov",
    "FacebookURL": "https://facebook.com/EvansForColorado",
    "XURL": "https://x.com/GabeEvansCO",
    "State": "CO"
  },
  {
    "FirstName": "John",
    "LastName": "Larson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2265",
    "Address": "1501 LHOB",
    "WebsiteURL": "https://larson.house.gov",
    "FacebookURL": "https://facebook.com/RepJohnLarson",
    "XURL": "https://x.com/RepJohnLarson",
    "State": "CT"
  },
  {
    "FirstName": "Joe",
    "LastName": "Courtney",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2076",
    "Address": "2449 RHOB",
    "WebsiteURL": "https://courtney.house.gov",
    "FacebookURL": "https://facebook.com/RepJoeCourtney",
    "XURL": "https://x.com/RepJoeCourtney",
    "State": "CT"
  },
  {
    "FirstName": "Rosa",
    "LastName": "DeLauro",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3661",
    "Address": "2413 RHOB",
    "WebsiteURL": "https://delauro.house.gov",
    "FacebookURL": "https://facebook.com/RepRosaDeLauro",
    "XURL": "https://x.com/rosadelauro",
    "State": "CT"
  },
  {
    "FirstName": "James",
    "LastName": "Himes",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5541",
    "Address": "2137 RHOB",
    "WebsiteURL": "https://himes.house.gov",
    "FacebookURL": "https://facebook.com/RepJimHimes",
    "XURL": "https://x.com/jahimes",
    "State": "CT"
  },
  {
    "FirstName": "Jahana",
    "LastName": "Hayes",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4476",
    "Address": "2049 RHOB",
    "WebsiteURL": "https://hayes.house.gov",
    "FacebookURL": "https://facebook.com/RepJahanaHayes",
    "XURL": "https://x.com/RepJahanaHayes",
    "State": "CT"
  },
  {
    "FirstName": "Sarah",
    "LastName": "McBride",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4165",
    "Address": "1306 LHOB",
    "WebsiteURL": "https://mcbride.house.gov",
    "FacebookURL": "https://facebook.com/SarahMcBrideDE",
    "XURL": "https://x.com/SarahMcBride",
    "State": "DE"
  },
  {
    "FirstName": "Eleanor",
    "LastName": "Norton",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8050",
    "Address": "2136 RHOB",
    "WebsiteURL": "https://norton.house.gov",
    "FacebookURL": "https://facebook.com/RepMattGaetz",
    "XURL": "https://x.com/RepMattGaetz",
    "State": "DC"
  },
  {
    "FirstName": "Jimmy",
    "LastName": "Patronis",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4136",
    "Address": "2021 RHOB",
    "WebsiteURL": "https://patronis.house.gov",
    "FacebookURL": "",
    "XURL": "",
    "State": "FL"
  },
  {
    "FirstName": "Neal",
    "LastName": "Dunn",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5235",
    "Address": "466 CHOB",
    "WebsiteURL": "https://dunn.house.gov",
    "FacebookURL": "https://facebook.com/DrNealDunnFL2",
    "XURL": "https://x.com/DrNealDunnFL2",
    "State": "FL"
  },
  {
    "FirstName": "Kat",
    "LastName": "Cammack",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5744",
    "Address": "2421 RHOB",
    "WebsiteURL": "https://cammack.house.gov",
    "FacebookURL": "https://facebook.com/RepKatCammack",
    "XURL": "https://x.com/RepKatCammack",
    "State": "FL"
  },
  {
    "FirstName": "Aaron",
    "LastName": "Bean",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-0123",
    "Address": "2459 RHOB",
    "WebsiteURL": "https://bean.house.gov",
    "FacebookURL": "https://facebook.com/RepAaronBean",
    "XURL": "https://x.com/RepAaronBean",
    "State": "FL"
  },
  {
    "FirstName": "John",
    "LastName": "Rutherford",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2501",
    "Address": "1711 LHOB",
    "WebsiteURL": "https://rutherford.house.gov",
    "FacebookURL": "https://facebook.com/RepRutherfordFL",
    "XURL": "https://x.com/RepRutherfordFL",
    "State": "FL"
  },
  {
    "FirstName": "Randy",
    "LastName": "Fine",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2706",
    "Address": "244 CHOB",
    "WebsiteURL": "https://fine.house.gov",
    "FacebookURL": "https://facebook.com/RepMichaelWaltz",
    "XURL": "https://x.com/michaelgwaltz",
    "State": "FL"
  },
  {
    "FirstName": "Cory",
    "LastName": "Mills",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4035",
    "Address": "346 CHOB",
    "WebsiteURL": "https://mills.house.gov",
    "FacebookURL": "https://facebook.com/RepCoryMills",
    "XURL": "https://x.com/RepCoryMills",
    "State": "FL"
  },
  {
    "FirstName": "Mike",
    "LastName": "Haridopolos",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3671",
    "Address": "1039 LHOB",
    "WebsiteURL": "https://haridopolos.house.gov",
    "FacebookURL": "https://facebook.com/MikeHaridopolos",
    "XURL": "https://x.com/MikeHaridopolos",
    "State": "FL"
  },
  {
    "FirstName": "Darren",
    "LastName": "Soto",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-9889",
    "Address": "2353 RHOB",
    "WebsiteURL": "https://soto.house.gov",
    "FacebookURL": "https://facebook.com/RepDarrenSoto",
    "XURL": "https://x.com/RepDarrenSoto",
    "State": "FL"
  },
  {
    "FirstName": "Maxwell",
    "LastName": "Frost",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2176",
    "Address": "1224 LHOB",
    "WebsiteURL": "https://frost.house.gov",
    "FacebookURL": "https://facebook.com/RepMaxwellFrost",
    "XURL": "https://x.com/RepMaxwellFrost",
    "State": "FL"
  },
  {
    "FirstName": "Daniel",
    "LastName": "Webster",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-1002",
    "Address": "2184 RHOB",
    "WebsiteURL": "https://webster.house.gov",
    "FacebookURL": "https://facebook.com/RepWebster",
    "XURL": "https://x.com/RepWebster",
    "State": "FL"
  },
  {
    "FirstName": "Gus",
    "LastName": "Bilirakis",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5755",
    "Address": "2306 RHOB",
    "WebsiteURL": "https://bilirakis.house.gov",
    "FacebookURL": "https://facebook.com/RepGusBilirakis",
    "XURL": "https://x.com/RepGusBilirakis",
    "State": "FL"
  },
  {
    "FirstName": "Anna Paulina",
    "LastName": "Luna",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5961",
    "Address": "226 CHOB",
    "WebsiteURL": "https://luna.house.gov",
    "FacebookURL": "https://facebook.com/RepLuna",
    "XURL": "https://x.com/RepLuna",
    "State": "FL"
  },
  {
    "FirstName": "Kathy",
    "LastName": "Castor",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3376",
    "Address": "2188 RHOB",
    "WebsiteURL": "https://castor.house.gov",
    "FacebookURL": "https://facebook.com/RepKathyCastor",
    "XURL": "https://x.com/USRepKCastor",
    "State": "FL"
  },
  {
    "FirstName": "Laurel",
    "LastName": "Lee",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5626",
    "Address": "2464 RHOB",
    "WebsiteURL": "https://laurellee.house.gov",
    "FacebookURL": "https://facebook.com/RepLaurelLee",
    "XURL": "https://x.com/RepLaurelLee",
    "State": "FL"
  },
  {
    "FirstName": "Vern",
    "LastName": "Buchanan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5015",
    "Address": "2409 RHOB",
    "WebsiteURL": "https://buchanan.house.gov",
    "FacebookURL": "https://facebook.com/RepVernBuchanan",
    "XURL": "https://x.com/VernBuchanan",
    "State": "FL"
  },
  {
    "FirstName": "W.",
    "LastName": "Steube",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5792",
    "Address": "2457 RHOB",
    "WebsiteURL": "https://steube.house.gov",
    "FacebookURL": "https://facebook.com/RepGregSteube",
    "XURL": "https://x.com/RepGregSteube",
    "State": "FL"
  },
  {
    "FirstName": "Scott",
    "LastName": "Franklin",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-1252",
    "Address": "2301 RHOB",
    "WebsiteURL": "https://franklin.house.gov",
    "FacebookURL": "https://facebook.com/RepScottFranklin",
    "XURL": "https://x.com/RepFranklin",
    "State": "FL"
  },
  {
    "FirstName": "Byron",
    "LastName": "Donalds",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2536",
    "Address": "1710 LHOB",
    "WebsiteURL": "https://donalds.house.gov",
    "FacebookURL": "https://facebook.com/RepByronDonalds",
    "XURL": "https://x.com/RepDonaldsPress",
    "State": "FL"
  },
  {
    "FirstName": "Sheila",
    "LastName": "Cherfilus-McCormick",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1313",
    "Address": "2442 RHOB",
    "WebsiteURL": "https://cherfilus-mccormick.house.gov",
    "FacebookURL": "https://facebook.com/RepSheilaCM",
    "XURL": "https://x.com/RepSheilaCM",
    "State": "FL"
  },
  {
    "FirstName": "Brian",
    "LastName": "Mast",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3026",
    "Address": "2182 RHOB",
    "WebsiteURL": "https://mast.house.gov",
    "FacebookURL": "https://facebook.com/RepBrianMast",
    "XURL": "https://x.com/RepBrianMast",
    "State": "FL"
  },
  {
    "FirstName": "Lois",
    "LastName": "Frankel",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-9890",
    "Address": "2305 RHOB",
    "WebsiteURL": "https://frankel.house.gov",
    "FacebookURL": "https://facebook.com/RepLoisFrankel",
    "XURL": "https://x.com/RepLoisFrankel",
    "State": "FL"
  },
  {
    "FirstName": "Jared",
    "LastName": "Moskowitz",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3001",
    "Address": "242 CHOB",
    "WebsiteURL": "https://moskowitz.house.gov",
    "FacebookURL": "https://facebook.com/RepMoskowitz",
    "XURL": "https://x.com/RepMoskowitz",
    "State": "FL"
  },
  {
    "FirstName": "Frederica",
    "LastName": "Wilson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4506",
    "Address": "2080 RHOB",
    "WebsiteURL": "https://wilson.house.gov",
    "FacebookURL": "https://facebook.com/RepFredericaWilson",
    "XURL": "https://x.com/RepWilson",
    "State": "FL"
  },
  {
    "FirstName": "Debbie",
    "LastName": "Wasserman Schultz",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7931",
    "Address": "270 CHOB",
    "WebsiteURL": "https://wassermanschultz.house.gov",
    "FacebookURL": "https://facebook.com/RepDWassermanSchultz",
    "XURL": "https://x.com/RepDWStweets",
    "State": "FL"
  },
  {
    "FirstName": "Mario",
    "LastName": "Diaz-Balart",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4211",
    "Address": "374 CHOB",
    "WebsiteURL": "https://mariodiazbalart.house.gov",
    "FacebookURL": "https://facebook.com/MarioDiazBalart",
    "XURL": "https://x.com/MarioDB",
    "State": "FL"
  },
  {
    "FirstName": "Maria",
    "LastName": "Salazar",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3931",
    "Address": "2162 RHOB",
    "WebsiteURL": "https://salazar.house.gov",
    "FacebookURL": "https://facebook.com/RepMariaSalazar",
    "XURL": "https://x.com/RepMaElvira",
    "State": "FL"
  },
  {
    "FirstName": "Carlos",
    "LastName": "Gimenez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2778",
    "Address": "448 CHOB",
    "WebsiteURL": "https://gimenez.house.gov",
    "FacebookURL": "https://facebook.com/RepCarlosGimenez",
    "XURL": "https://x.com/RepCarlos",
    "State": "FL"
  },
  {
    "FirstName": "Earl",
    "LastName": "Carter",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5831",
    "Address": "2432 RHOB",
    "WebsiteURL": "https://buddycarter.house.gov",
    "FacebookURL": "https://facebook.com/RepBuddyCarter",
    "XURL": "https://x.com/RepBuddyCarter",
    "State": "GA"
  },
  {
    "FirstName": "Sanford",
    "LastName": "Bishop",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3631",
    "Address": "2407 RHOB",
    "WebsiteURL": "https://bishop.house.gov",
    "FacebookURL": "https://facebook.com/repsanfordbishop",
    "XURL": "https://x.com/SanfordBishop",
    "State": "GA"
  },
  {
    "FirstName": "Brian",
    "LastName": "Jack",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5901",
    "Address": "1320 LHOB",
    "WebsiteURL": "https://jack.house.gov",
    "FacebookURL": "https://facebook.com/BrianJackGA",
    "XURL": "https://x.com/BrianJackGA",
    "State": "GA"
  },
  {
    "FirstName": "Henry",
    "LastName": "Johnson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1605",
    "Address": "2240 RHOB",
    "WebsiteURL": "https://hankjohnson.house.gov",
    "FacebookURL": "https://facebook.com/RepHankJohnson",
    "XURL": "https://x.com/RepHankJohnson",
    "State": "GA"
  },
  {
    "FirstName": "Nikema",
    "LastName": "Williams",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3801",
    "Address": "1406 LHOB",
    "WebsiteURL": "https://nikemawilliams.house.gov",
    "FacebookURL": "https://facebook.com/RepNikema",
    "XURL": "https://x.com/RepNikema",
    "State": "GA"
  },
  {
    "FirstName": "Lucy",
    "LastName": "McBath",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4501",
    "Address": "2246 RHOB",
    "WebsiteURL": "https://mcbath.house.gov",
    "FacebookURL": "https://facebook.com/RepLucyMcBath",
    "XURL": "https://x.com/RepLucyMcBath",
    "State": "GA"
  },
  {
    "FirstName": "Richard",
    "LastName": "McCormick",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4272",
    "Address": "1719 LHOB",
    "WebsiteURL": "https://mccormick.house.gov",
    "FacebookURL": "https://facebook.com/RepMcCormick",
    "XURL": "https://x.com/RepMcCormick",
    "State": "GA"
  },
  {
    "FirstName": "Austin",
    "LastName": "Scott",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6531",
    "Address": "2185 RHOB",
    "WebsiteURL": "https://austinscott.house.gov",
    "FacebookURL": "https://facebook.com/RepAustinScott",
    "XURL": "https://x.com/RepAustinScott",
    "State": "GA"
  },
  {
    "FirstName": "Andrew",
    "LastName": "Clyde",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-9893",
    "Address": "445 CHOB",
    "WebsiteURL": "https://clyde.house.gov",
    "FacebookURL": "https://facebook.com/RepAndrewClyde",
    "XURL": "https://x.com/RepAndrewClyde",
    "State": "GA"
  },
  {
    "FirstName": "Mike",
    "LastName": "Collins",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4101",
    "Address": "2351 RHOB",
    "WebsiteURL": "https://collins.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeCollins",
    "XURL": "https://x.com/RepMikeCollins",
    "State": "GA"
  },
  {
    "FirstName": "Barry",
    "LastName": "Loudermilk",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2931",
    "Address": "2133 RHOB",
    "WebsiteURL": "https://loudermilk.house.gov",
    "FacebookURL": "https://facebook.com/RepLoudermilk",
    "XURL": "https://x.com/RepLoudermilk",
    "State": "GA"
  },
  {
    "FirstName": "Rick",
    "LastName": "Allen",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2823",
    "Address": "462 CHOB",
    "WebsiteURL": "https://allen.house.gov",
    "FacebookURL": "https://facebook.com/RepRickAllen",
    "XURL": "https://x.com/RepRickAllen",
    "State": "GA"
  },
  {
    "FirstName": "David",
    "LastName": "Scott",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2939",
    "Address": "468 CHOB",
    "WebsiteURL": "https://davidscott.house.gov",
    "FacebookURL": "https://facebook.com/RepDavidScott",
    "XURL": "https://x.com/repdavidscott",
    "State": "GA"
  },
  {
    "FirstName": "Marjorie",
    "LastName": "Greene",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5211",
    "Address": "2201 RHOB",
    "WebsiteURL": "https://greene.house.gov",
    "FacebookURL": "https://facebook.com/RepMTG",
    "XURL": "https://x.com/RepMTG",
    "State": "GA"
  },
  {
    "FirstName": "James",
    "LastName": "Moylan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-1188",
    "Address": "228 CHOB",
    "WebsiteURL": "https://moylan.house.gov",
    "FacebookURL": "",
    "XURL": "",
    "State": "GU"
  },
  {
    "FirstName": "Ed",
    "LastName": "Case",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2726",
    "Address": "2210 RHOB",
    "WebsiteURL": "https://case.house.gov",
    "FacebookURL": "https://facebook.com/RepEdCase",
    "XURL": "https://x.com/RepEdCase",
    "State": "HI"
  },
  {
    "FirstName": "Jill",
    "LastName": "Tokuda",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4906",
    "Address": "1027 LHOB",
    "WebsiteURL": "https://tokuda.house.gov",
    "FacebookURL": "https://facebook.com/RepJillTokuda",
    "XURL": "https://x.com/RepJillTokuda",
    "State": "HI"
  },
  {
    "FirstName": "Russ",
    "LastName": "Fulcher",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6611",
    "Address": "1514 LHOB",
    "WebsiteURL": "https://fulcher.house.gov",
    "FacebookURL": "https://facebook.com/RepRussFulcher",
    "XURL": "https://x.com/RepRussFulcher",
    "State": "ID"
  },
  {
    "FirstName": "Michael",
    "LastName": "Simpson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5531",
    "Address": "2084 RHOB",
    "WebsiteURL": "https://simpson.house.gov",
    "FacebookURL": "https://facebook.com/RepSimp",
    "XURL": "https://x.com/CongSimpson",
    "State": "ID"
  },
  {
    "FirstName": "Jonathan",
    "LastName": "Jackson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4372",
    "Address": "1632 LHOB",
    "WebsiteURL": "https://jonathanjackson.house.gov",
    "FacebookURL": "https://facebook.com/RepJonathanJackson",
    "XURL": "https://x.com/RepJackson",
    "State": "IL"
  },
  {
    "FirstName": "Robin",
    "LastName": "Kelly",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-0773",
    "Address": "2329 RHOB",
    "WebsiteURL": "https://robinkelly.house.gov",
    "FacebookURL": "https://facebook.com/RepRobinKelly",
    "XURL": "https://x.com/RepRobinKelly",
    "State": "IL"
  },
  {
    "FirstName": "Delia",
    "LastName": "Ramirez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5701",
    "Address": "1523 LHOB",
    "WebsiteURL": "https://ramirez.house.gov",
    "FacebookURL": "https://facebook.com/RepDeliaRamirez",
    "XURL": "https://x.com/RepDeliaRamirez",
    "State": "IL"
  },
  {
    "FirstName": "Jesus",
    "LastName": "Garcia",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8203",
    "Address": "2334 RHOB",
    "WebsiteURL": "https://chuygarcia.house.gov",
    "FacebookURL": "https://facebook.com/RepChuyGarcia",
    "XURL": "https://x.com/RepChuyGarcia",
    "State": "IL"
  },
  {
    "FirstName": "Mike",
    "LastName": "Quigley",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4061",
    "Address": "2083 RHOB",
    "WebsiteURL": "https://quigley.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeQuigley",
    "XURL": "https://x.com/RepMikeQuigley",
    "State": "IL"
  },
  {
    "FirstName": "Sean",
    "LastName": "Casten",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4561",
    "Address": "2440 RHOB",
    "WebsiteURL": "https://casten.house.gov",
    "FacebookURL": "https://facebook.com/RepSeanCasten",
    "XURL": "https://x.com/RepCasten",
    "State": "IL"
  },
  {
    "FirstName": "Danny",
    "LastName": "Davis",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5006",
    "Address": "2159 RHOB",
    "WebsiteURL": "https://davis.house.gov",
    "FacebookURL": "https://facebook.com/RepDannyDavis",
    "XURL": "https://x.com/RepDannyDavis",
    "State": "IL"
  },
  {
    "FirstName": "Raja",
    "LastName": "Krishnamoorthi",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3711",
    "Address": "2367 RHOB",
    "WebsiteURL": "https://krishnamoorthi.house.gov",
    "FacebookURL": "https://facebook.com/CongressmanRaja",
    "XURL": "https://x.com/CongressmanRaja",
    "State": "IL"
  },
  {
    "FirstName": "Janice",
    "LastName": "Schakowsky",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2111",
    "Address": "2408 RHOB",
    "WebsiteURL": "https://schakowsky.house.gov",
    "FacebookURL": "https://facebook.com/JanSchakowsky",
    "XURL": "https://x.com/janschakowsky",
    "State": "IL"
  },
  {
    "FirstName": "Bradley",
    "LastName": "Schneider",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4835",
    "Address": "300 CHOB",
    "WebsiteURL": "https://schneider.house.gov",
    "FacebookURL": "https://facebook.com/RepSchneider",
    "XURL": "https://x.com/RepSchneider",
    "State": "IL"
  },
  {
    "FirstName": "Bill",
    "LastName": "Foster",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3515",
    "Address": "2366 RHOB",
    "WebsiteURL": "https://foster.house.gov",
    "FacebookURL": "https://facebook.com/RepBillFoster",
    "XURL": "https://x.com/RepBillFoster",
    "State": "IL"
  },
  {
    "FirstName": "Mike",
    "LastName": "Bost",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5661",
    "Address": "352 CHOB",
    "WebsiteURL": "https://bost.house.gov",
    "FacebookURL": "https://facebook.com/RepBost",
    "XURL": "https://x.com/RepBost",
    "State": "IL"
  },
  {
    "FirstName": "Nikki",
    "LastName": "Budzinski",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2371",
    "Address": "1717 LHOB",
    "WebsiteURL": "https://budzinski.house.gov",
    "FacebookURL": "https://facebook.com/RepNikkiB",
    "XURL": "https://x.com/RepNikkiB",
    "State": "IL"
  },
  {
    "FirstName": "Lauren",
    "LastName": "Underwood",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2976",
    "Address": "2228 RHOB",
    "WebsiteURL": "https://underwood.house.gov",
    "FacebookURL": "https://facebook.com/RepUnderwood",
    "XURL": "https://x.com/RepUnderwood",
    "State": "IL"
  },
  {
    "FirstName": "Mary",
    "LastName": "Miller",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5271",
    "Address": "1740 LHOB",
    "WebsiteURL": "https://marymiller.house.gov",
    "FacebookURL": "https://facebook.com/RepMaryMiller",
    "XURL": "https://x.com/RepMaryMiller",
    "State": "IL"
  },
  {
    "FirstName": "Darin",
    "LastName": "LaHood",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6201",
    "Address": "503 CHOB",
    "WebsiteURL": "https://lahood.house.gov",
    "FacebookURL": "https://facebook.com/RepDarinLaHood",
    "XURL": "https://x.com/RepLaHood",
    "State": "IL"
  },
  {
    "FirstName": "Eric",
    "LastName": "Sorensen",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5905",
    "Address": "1314 LHOB",
    "WebsiteURL": "https://sorensen.house.gov",
    "FacebookURL": "https://facebook.com/RepSorensen",
    "XURL": "https://x.com/RepSorensen",
    "State": "IL"
  },
  {
    "FirstName": "Frank",
    "LastName": "Mrvan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2461",
    "Address": "2441 RHOB",
    "WebsiteURL": "https://mrvan.house.gov",
    "FacebookURL": "https://facebook.com/RepFrankMrvan",
    "XURL": "https://x.com/RepFrankMrvan",
    "State": "IN"
  },
  {
    "FirstName": "Rudy",
    "LastName": "Yakym",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3915",
    "Address": "349 CHOB",
    "WebsiteURL": "https://yakym.house.gov",
    "FacebookURL": "https://facebook.com/RepRudyYakym",
    "XURL": "https://x.com/RepRudyYakym",
    "State": "IN"
  },
  {
    "FirstName": "Marlin",
    "LastName": "Stutzman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4436",
    "Address": "404 CHOB",
    "WebsiteURL": "https://stutzman.house.gov",
    "FacebookURL": "https://facebook.com/MarlinStutzman",
    "XURL": "https://x.com/MarlinStutzman",
    "State": "IN"
  },
  {
    "FirstName": "James",
    "LastName": "Baird",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5037",
    "Address": "2303 RHOB",
    "WebsiteURL": "https://baird.house.gov",
    "FacebookURL": "https://facebook.com/RepJimBaird",
    "XURL": "https://x.com/RepJimBaird",
    "State": "IN"
  },
  {
    "FirstName": "Victoria",
    "LastName": "Spartz",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2276",
    "Address": "1609 LHOB",
    "WebsiteURL": "https://spartz.house.gov",
    "FacebookURL": "https://facebook.com/RepVictoriaSpartz",
    "XURL": "https://x.com/RepSpartz",
    "State": "IN"
  },
  {
    "FirstName": "Jefferson",
    "LastName": "Shreve",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3021",
    "Address": "224 CHOB",
    "WebsiteURL": "https://shreve.house.gov",
    "FacebookURL": "https://facebook.com/JeffersonShreve",
    "XURL": "https://x.com/JeffersonShreve",
    "State": "IN"
  },
  {
    "FirstName": "Andre",
    "LastName": "Carson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4011",
    "Address": "2135 RHOB",
    "WebsiteURL": "https://carson.house.gov",
    "FacebookURL": "https://facebook.com/RepAndreCarson",
    "XURL": "https://x.com/RepAndreCarson",
    "State": "IN"
  },
  {
    "FirstName": "Mark",
    "LastName": "Messmer",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4636",
    "Address": "1208 LHOB",
    "WebsiteURL": "https://messmer.house.gov",
    "FacebookURL": "https://facebook.com/MessmerForCongress",
    "XURL": "https://x.com/MarkMessmer",
    "State": "IN"
  },
  {
    "FirstName": "Erin",
    "LastName": "Houchin",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5315",
    "Address": "342 CHOB",
    "WebsiteURL": "https://houchin.house.gov",
    "FacebookURL": "https://facebook.com/RoarkForIndiana",
    "XURL": "https://x.com/KeilRoark",
    "State": "IN"
  },
  {
    "FirstName": "Mariannette",
    "LastName": "Miller-Meeks",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6576",
    "Address": "504 CHOB",
    "WebsiteURL": "https://millermeeks.house.gov",
    "FacebookURL": "https://facebook.com/RepMillerMeeks",
    "XURL": "https://x.com/RepMillerMeeks",
    "State": "IA"
  },
  {
    "FirstName": "Ashley",
    "LastName": "Hinson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2911",
    "Address": "2458 RHOB",
    "WebsiteURL": "https://hinson.house.gov",
    "FacebookURL": "https://facebook.com/RepAshleyHinson",
    "XURL": "https://x.com/RepAshleyHinson",
    "State": "IA"
  },
  {
    "FirstName": "Zachary",
    "LastName": "Nunn",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5476",
    "Address": "1410 LHOB",
    "WebsiteURL": "https://nunn.house.gov",
    "FacebookURL": "https://facebook.com/RepZachNunn",
    "XURL": "https://x.com/RepZachNunn",
    "State": "IA"
  },
  {
    "FirstName": "Randy",
    "LastName": "Feenstra",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4426",
    "Address": "2434 RHOB",
    "WebsiteURL": "https://feenstra.house.gov",
    "FacebookURL": "https://facebook.com/RepFeenstra",
    "XURL": "https://x.com/RepFeenstra",
    "State": "IA"
  },
  {
    "FirstName": "Tracey",
    "LastName": "Mann",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2715",
    "Address": "344 CHOB",
    "WebsiteURL": "https://mann.house.gov",
    "FacebookURL": "https://facebook.com/RepTraceyMann",
    "XURL": "https://x.com/RepTraceyMann",
    "State": "KS"
  },
  {
    "FirstName": "Derek",
    "LastName": "Schmidt",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6601",
    "Address": "1223 LHOB",
    "WebsiteURL": "https://schmidt.house.gov",
    "FacebookURL": "https://facebook.com/DerekSchmidtKS",
    "XURL": "https://x.com/DerekSchmidtKS",
    "State": "KS"
  },
  {
    "FirstName": "Sharice",
    "LastName": "Davids",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2865",
    "Address": "2435 RHOB",
    "WebsiteURL": "https://davids.house.gov",
    "FacebookURL": "https://facebook.com/RepShariceDavids",
    "XURL": "https://x.com/RepDavids",
    "State": "KS"
  },
  {
    "FirstName": "Ron",
    "LastName": "Estes",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6216",
    "Address": "2234 RHOB",
    "WebsiteURL": "https://estes.house.gov",
    "FacebookURL": "https://facebook.com/RepRonEstes",
    "XURL": "https://x.com/RepRonEstes",
    "State": "KS"
  },
  {
    "FirstName": "James",
    "LastName": "Comer",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3115",
    "Address": "2410 RHOB",
    "WebsiteURL": "https://comer.house.gov",
    "FacebookURL": "https://facebook.com/RepJamesComer",
    "XURL": "https://x.com/RepJamesComer",
    "State": "KY"
  },
  {
    "FirstName": "Brett",
    "LastName": "Guthrie",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3501",
    "Address": "2161 RHOB",
    "WebsiteURL": "https://guthrie.house.gov",
    "FacebookURL": "https://facebook.com/RepBrettGuthrie",
    "XURL": "https://x.com/RepGuthrie",
    "State": "KY"
  },
  {
    "FirstName": "Morgan",
    "LastName": "McGarvey",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5401",
    "Address": "1527 LHOB",
    "WebsiteURL": "https://mcgarvey.house.gov",
    "FacebookURL": "https://facebook.com/RepMorganMcGarvey",
    "XURL": "https://x.com/RepMcGarvey",
    "State": "KY"
  },
  {
    "FirstName": "Thomas",
    "LastName": "Massie",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3465",
    "Address": "2371 RHOB",
    "WebsiteURL": "https://massie.house.gov",
    "FacebookURL": "https://facebook.com/RepThomasMassie",
    "XURL": "https://x.com/RepThomasMassie",
    "State": "KY"
  },
  {
    "FirstName": "Harold",
    "LastName": "Rogers",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4601",
    "Address": "2406 RHOB",
    "WebsiteURL": "https://halrogers.house.gov",
    "FacebookURL": "https://facebook.com/RepHalRogers",
    "XURL": "https://x.com/RepHalRogers",
    "State": "KY"
  },
  {
    "FirstName": "Andy",
    "LastName": "Barr",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4706",
    "Address": "2430 RHOB",
    "WebsiteURL": "https://barr.house.gov",
    "FacebookURL": "https://facebook.com/RepAndyBarr",
    "XURL": "https://x.com/RepAndyBarr",
    "State": "KY"
  },
  {
    "FirstName": "Steve",
    "LastName": "Scalise",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3015",
    "Address": "266 CHOB",
    "WebsiteURL": "https://scalise.house.gov",
    "FacebookURL": "https://facebook.com/RepSteveScalise",
    "XURL": "https://x.com/SteveScalise",
    "State": "LA"
  },
  {
    "FirstName": "Troy",
    "LastName": "Carter",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6636",
    "Address": "442 CHOB",
    "WebsiteURL": "https://troycarter.house.gov",
    "FacebookURL": "https://facebook.com/RepTroyCarter",
    "XURL": "https://x.com/RepTroyCarter",
    "State": "LA"
  },
  {
    "FirstName": "Clay",
    "LastName": "Higgins",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2031",
    "Address": "572 CHOB",
    "WebsiteURL": "https://clayhiggins.house.gov",
    "FacebookURL": "https://facebook.com/RepClayHiggins",
    "XURL": "https://x.com/RepClayHiggins",
    "State": "LA"
  },
  {
    "FirstName": "Mike",
    "LastName": "Johnson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2777",
    "Address": "521 CHOB",
    "WebsiteURL": "https://mikejohnson.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeJohnson",
    "XURL": "https://x.com/SpeakerJohnson",
    "State": "LA"
  },
  {
    "FirstName": "Julia",
    "LastName": "Letlow",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-8490",
    "Address": "142 CHOB",
    "WebsiteURL": "https://letlow.house.gov",
    "FacebookURL": "https://facebook.com/RepJuliaLetlow",
    "XURL": "https://x.com/RepJuliaLetlow",
    "State": "LA"
  },
  {
    "FirstName": "Cleo",
    "LastName": "Fields",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3901",
    "Address": "2349 RHOB",
    "WebsiteURL": "https://fields.house.gov",
    "FacebookURL": "https://facebook.com/CleoFieldsLA",
    "XURL": "https://x.com/CleoFields",
    "State": "LA"
  },
  {
    "FirstName": "Chellie",
    "LastName": "Pingree",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6116",
    "Address": "2354 RHOB",
    "WebsiteURL": "https://pingree.house.gov",
    "FacebookURL": "https://facebook.com/ChelliePingree",
    "XURL": "https://x.com/chelliepingree",
    "State": "ME"
  },
  {
    "FirstName": "Jared",
    "LastName": "Golden",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6306",
    "Address": "1107 LHOB",
    "WebsiteURL": "https://golden.house.gov",
    "FacebookURL": "https://facebook.com/RepJaredGolden",
    "XURL": "https://x.com/RepJaredGolden",
    "State": "ME"
  },
  {
    "FirstName": "Andy",
    "LastName": "Harris",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5311",
    "Address": "1536 LHOB",
    "WebsiteURL": "https://harris.house.gov",
    "FacebookURL": "https://facebook.com/RepAndyHarrisMD",
    "XURL": "https://x.com/RepAndyHarrisMD",
    "State": "MD"
  },
  {
    "FirstName": "Johnny",
    "LastName": "Olszewski",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3061",
    "Address": "1339 LHOB",
    "WebsiteURL": "https://olszewski.house.gov",
    "FacebookURL": "https://facebook.com/JohnnyOlszewski",
    "XURL": "https://x.com/JohnnyOlszewski",
    "State": "MD"
  },
  {
    "FirstName": "Sarah",
    "LastName": "Elfreth",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4016",
    "Address": "1213 LHOB",
    "WebsiteURL": "https://elfreth.house.gov",
    "FacebookURL": "https://facebook.com/SarahElfreth",
    "XURL": "https://x.com/SarahElfreth",
    "State": "MD"
  },
  {
    "FirstName": "Glenn",
    "LastName": "Ivey",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8699",
    "Address": "1610 LHOB",
    "WebsiteURL": "https://ivey.house.gov",
    "FacebookURL": "https://facebook.com/RepGlennIvey",
    "XURL": "https://x.com/RepGlennIvey",
    "State": "MD"
  },
  {
    "FirstName": "Steny",
    "LastName": "Hoyer",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4131",
    "Address": "1705 LHOB",
    "WebsiteURL": "https://hoyer.house.gov",
    "FacebookURL": "https://facebook.com/StenyHoyer",
    "XURL": "https://x.com/StenyHoyer",
    "State": "MD"
  },
  {
    "FirstName": "April",
    "LastName": "McClain Delaney",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2721",
    "Address": "1130 LHOB",
    "WebsiteURL": "https://mcclaindelaney.house.gov",
    "FacebookURL": "https://facebook.com/AprilMcClainDelaney",
    "XURL": "https://x.com/AprilMcDelaney",
    "State": "MD"
  },
  {
    "FirstName": "Kweisi",
    "LastName": "Mfume",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4741",
    "Address": "2263 RHOB",
    "WebsiteURL": "https://mfume.house.gov",
    "FacebookURL": "https://facebook.com/RepKweisiMfume",
    "XURL": "https://x.com/RepKweisiMfume",
    "State": "MD"
  },
  {
    "FirstName": "Jamie",
    "LastName": "Raskin",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5341",
    "Address": "2242 RHOB",
    "WebsiteURL": "https://raskin.house.gov",
    "FacebookURL": "https://facebook.com/JamieRaskin",
    "XURL": "https://x.com/RepRaskin",
    "State": "MD"
  },
  {
    "FirstName": "Richard",
    "LastName": "Neal",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5601",
    "Address": "372 CHOB",
    "WebsiteURL": "https://neal.house.gov",
    "FacebookURL": "https://facebook.com/RepRichardNeal",
    "XURL": "https://x.com/RepRichardNeal",
    "State": "MA"
  },
  {
    "FirstName": "James",
    "LastName": "McGovern",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6101",
    "Address": "370 CHOB",
    "WebsiteURL": "https://mcgovern.house.gov",
    "FacebookURL": "https://facebook.com/RepJimMcGovern",
    "XURL": "https://x.com/RepMcGovern",
    "State": "MA"
  },
  {
    "FirstName": "Lori",
    "LastName": "Trahan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3411",
    "Address": "2233 RHOB",
    "WebsiteURL": "https://trahan.house.gov",
    "FacebookURL": "https://facebook.com/RepLoriTrahan",
    "XURL": "https://x.com/RepLoriTrahan",
    "State": "MA"
  },
  {
    "FirstName": "Jake",
    "LastName": "Auchincloss",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5931",
    "Address": "1524 LHOB",
    "WebsiteURL": "https://auchincloss.house.gov",
    "FacebookURL": "https://facebook.com/RepAuchincloss",
    "XURL": "https://x.com/RepAuchincloss",
    "State": "MA"
  },
  {
    "FirstName": "Katherine",
    "LastName": "Clark",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2836",
    "Address": "2368 RHOB",
    "WebsiteURL": "https://katherineclark.house.govindex.cfm/home",
    "FacebookURL": "https://facebook.com/RepKatherineClark",
    "XURL": "https://x.com/RepKClark",
    "State": "MA"
  },
  {
    "FirstName": "Seth",
    "LastName": "Moulton",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8020",
    "Address": "1126 LHOB",
    "WebsiteURL": "https://moulton.house.gov",
    "FacebookURL": "https://facebook.com/RepMoulton",
    "XURL": "https://x.com/RepMoulton",
    "State": "MA"
  },
  {
    "FirstName": "Ayanna",
    "LastName": "Pressley",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5111",
    "Address": "402 CHOB",
    "WebsiteURL": "https://pressley.house.gov",
    "FacebookURL": "https://facebook.com/AyannaPressley",
    "XURL": "https://x.com/AyannaPressley",
    "State": "MA"
  },
  {
    "FirstName": "Stephen",
    "LastName": "Lynch",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8273",
    "Address": "2109 RHOB",
    "WebsiteURL": "https://lynch.house.gov",
    "FacebookURL": "https://facebook.com/RepStephenLynch",
    "XURL": "https://x.com/RepStephenLynch",
    "State": "MA"
  },
  {
    "FirstName": "William",
    "LastName": "Keating",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3111",
    "Address": "2372 RHOB",
    "WebsiteURL": "https://keating.house.gov",
    "FacebookURL": "https://facebook.com/RepBillKeating",
    "XURL": "https://x.com/RepBillKeating",
    "State": "MA"
  },
  {
    "FirstName": "Jack",
    "LastName": "Bergman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4735",
    "Address": "566 CHOB",
    "WebsiteURL": "https://bergman.house.gov",
    "FacebookURL": "https://facebook.com/RepJackBergman",
    "XURL": "https://x.com/RepJackBergman",
    "State": "MI"
  },
  {
    "FirstName": "John",
    "LastName": "Moolenaar",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3561",
    "Address": "246 CHOB",
    "WebsiteURL": "https://moolenaar.house.gov",
    "FacebookURL": "https://facebook.com/RepMoolenaar",
    "XURL": "https://x.com/RepMoolenaar",
    "State": "MI"
  },
  {
    "FirstName": "Hillary",
    "LastName": "Scholten",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3831",
    "Address": "1317 LHOB",
    "WebsiteURL": "https://scholten.house.gov",
    "FacebookURL": "https://facebook.com/RepHillaryScholten",
    "XURL": "https://x.com/RepScholten",
    "State": "MI"
  },
  {
    "FirstName": "Bill",
    "LastName": "Huizenga",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4401",
    "Address": "2232 RHOB",
    "WebsiteURL": "https://huizenga.house.gov",
    "FacebookURL": "https://facebook.com/RepBillHuizenga",
    "XURL": "https://x.com/RepHuizenga",
    "State": "MI"
  },
  {
    "FirstName": "Tim",
    "LastName": "Walberg",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6276",
    "Address": "2266 RHOB",
    "WebsiteURL": "https://walberg.house.gov",
    "FacebookURL": "https://facebook.com/RepTimWalberg",
    "XURL": "https://x.com/RepTimWalberg",
    "State": "MI"
  },
  {
    "FirstName": "Debbie",
    "LastName": "Dingell",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4071",
    "Address": "102 CHOB",
    "WebsiteURL": "https://debbiedingell.house.gov",
    "FacebookURL": "https://facebook.com/RepDebbieDingell",
    "XURL": "https://x.com/RepDingell",
    "State": "MI"
  },
  {
    "FirstName": "Tom",
    "LastName": "Barrett",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4872",
    "Address": "1232 LHOB",
    "WebsiteURL": "https://barrett.house.gov",
    "FacebookURL": "https://facebook.com/RepTomBarrett",
    "XURL": "https://x.com/TomBarrettMI",
    "State": "MI"
  },
  {
    "FirstName": "Kristen",
    "LastName": "McDonald Rivet",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3611",
    "Address": "1408 LHOB",
    "WebsiteURL": "https://mcdonaldrivet.house.gov",
    "FacebookURL": "https://facebook.com/KristenMcDonaldRivet",
    "XURL": "https://x.com/KristenMcDonald",
    "State": "MI"
  },
  {
    "FirstName": "Lisa",
    "LastName": "McClain",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2106",
    "Address": "562 CHOB",
    "WebsiteURL": "https://mcclain.house.gov",
    "FacebookURL": "https://facebook.com/RepLisaMcClain",
    "XURL": "https://x.com/RepLisaMcClain",
    "State": "MI"
  },
  {
    "FirstName": "John",
    "LastName": "James",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4961",
    "Address": "1519 LHOB",
    "WebsiteURL": "https://james.house.gov",
    "FacebookURL": "https://facebook.com/RepJohnJames",
    "XURL": "https://x.com/RepJohnJames",
    "State": "MI"
  },
  {
    "FirstName": "Haley",
    "LastName": "Stevens",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8171",
    "Address": "2411 RHOB",
    "WebsiteURL": "https://stevens.house.gov",
    "FacebookURL": "https://facebook.com/RepHaleyStevens",
    "XURL": "https://x.com/RepHaleyStevens",
    "State": "MI"
  },
  {
    "FirstName": "Rashida",
    "LastName": "Tlaib",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5126",
    "Address": "2438 RHOB",
    "WebsiteURL": "https://tlaib.house.gov",
    "FacebookURL": "https://facebook.com/RepRashidaTlaib",
    "XURL": "https://x.com/RepRashidaTlaib",
    "State": "MI"
  },
  {
    "FirstName": "Shri",
    "LastName": "Thanedar",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5802",
    "Address": "154 CHOB",
    "WebsiteURL": "https://thanedar.house.gov",
    "FacebookURL": "https://facebook.com/RepShriThanedar",
    "XURL": "https://x.com/RepShriThanedar",
    "State": "MI"
  },
  {
    "FirstName": "Brad",
    "LastName": "Finstad",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2472",
    "Address": "2418 RHOB",
    "WebsiteURL": "https://finstad.house.gov",
    "FacebookURL": "https://facebook.com/RepBradFinstad",
    "XURL": "https://x.com/RepBradFinstad",
    "State": "MN"
  },
  {
    "FirstName": "Angie",
    "LastName": "Craig",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2271",
    "Address": "2052 RHOB",
    "WebsiteURL": "https://craig.house.gov",
    "FacebookURL": "https://facebook.com/RepAngieCraig",
    "XURL": "https://x.com/RepAngieCraig",
    "State": "MN"
  },
  {
    "FirstName": "Kelly",
    "LastName": "Morrison",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2871",
    "Address": "1205 LHOB",
    "WebsiteURL": "https://morrison.house.gov",
    "FacebookURL": "https://facebook.com/KellyForMN",
    "XURL": "https://x.com/Morrison4MN",
    "State": "MN"
  },
  {
    "FirstName": "Betty",
    "LastName": "McCollum",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6631",
    "Address": "2426 RHOB",
    "WebsiteURL": "https://mccollum.house.gov",
    "FacebookURL": "https://facebook.com/RepBettyMcCollum",
    "XURL": "https://x.com/BettyMcCollum04",
    "State": "MN"
  },
  {
    "FirstName": "Ilhan",
    "LastName": "Omar",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4755",
    "Address": "1730 LHOB",
    "WebsiteURL": "https://omar.house.gov",
    "FacebookURL": "https://facebook.com/RepIlhan",
    "XURL": "https://x.com/Ilhan",
    "State": "MN"
  },
  {
    "FirstName": "Tom",
    "LastName": "Emmer",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2331",
    "Address": "326 CHOB",
    "WebsiteURL": "https://emmer.house.gov",
    "FacebookURL": "https://facebook.com/RepTomEmmer",
    "XURL": "https://x.com/RepTomEmmer",
    "State": "MN"
  },
  {
    "FirstName": "Michelle",
    "LastName": "Fischbach",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2165",
    "Address": "2229 RHOB",
    "WebsiteURL": "https://fischbach.house.gov",
    "FacebookURL": "https://facebook.com/RepFischbach",
    "XURL": "https://x.com/RepFischbach",
    "State": "MN"
  },
  {
    "FirstName": "Pete",
    "LastName": "Stauber",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6211",
    "Address": "145 CHOB",
    "WebsiteURL": "https://stauber.house.gov",
    "FacebookURL": "https://facebook.com/RepPeteStauber",
    "XURL": "https://x.com/RepStauber",
    "State": "MN"
  },
  {
    "FirstName": "Trent",
    "LastName": "Kelly",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4306",
    "Address": "2243 RHOB",
    "WebsiteURL": "https://trentkelly.house.gov",
    "FacebookURL": "https://facebook.com/RepTrentKelly",
    "XURL": "https://x.com/RepTrentKelly",
    "State": "MS"
  },
  {
    "FirstName": "Bennie",
    "LastName": "Thompson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5876",
    "Address": "2466 RHOB",
    "WebsiteURL": "https://benniethompson.house.gov",
    "FacebookURL": "https://facebook.com/BennieGThompson",
    "XURL": "https://x.com/BennieGThompson",
    "State": "MS"
  },
  {
    "FirstName": "Michael",
    "LastName": "Guest",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5031",
    "Address": "450 CHOB",
    "WebsiteURL": "https://guest.house.gov",
    "FacebookURL": "https://facebook.com/RepMichaelGuest",
    "XURL": "https://x.com/RepMichaelGuest",
    "State": "MS"
  },
  {
    "FirstName": "Mike",
    "LastName": "Ezell",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5772",
    "Address": "443 CHOB",
    "WebsiteURL": "https://ezell.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeEzell",
    "XURL": "https://x.com/RepEzell",
    "State": "MS"
  },
  {
    "FirstName": "Wesley",
    "LastName": "Bell",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2406",
    "Address": "1429 LHOB",
    "WebsiteURL": "https://bell.house.gov",
    "FacebookURL": "https://facebook.com/RepCori",
    "XURL": "https://x.com/RepCori",
    "State": "MO"
  },
  {
    "FirstName": "Ann",
    "LastName": "Wagner",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-1621",
    "Address": "2350 RHOB",
    "WebsiteURL": "https://wagner.house.gov",
    "FacebookURL": "https://facebook.com/RepAnnWagner",
    "XURL": "https://x.com/RepAnnWagner",
    "State": "MO"
  },
  {
    "FirstName": "Robert",
    "LastName": "Onder",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2956",
    "Address": "1113 LHOB",
    "WebsiteURL": "https://onder.house.gov",
    "FacebookURL": "https://facebook.com/BlaineLuetkemeyer",
    "XURL": "https://x.com/RepBlaine",
    "State": "MO"
  },
  {
    "FirstName": "Mark",
    "LastName": "Alford",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2876",
    "Address": "328 CHOB",
    "WebsiteURL": "https://alford.house.gov",
    "FacebookURL": "https://facebook.com/RepMarkAlford",
    "XURL": "https://x.com/RepMarkAlford",
    "State": "MO"
  },
  {
    "FirstName": "Emanuel",
    "LastName": "Cleaver",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4535",
    "Address": "2217 RHOB",
    "WebsiteURL": "https://cleaver.house.gov",
    "FacebookURL": "https://facebook.com/emanuelcleaverii",
    "XURL": "https://x.com/repcleaver",
    "State": "MO"
  },
  {
    "FirstName": "Sam",
    "LastName": "Graves",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-7041",
    "Address": "1135 LHOB",
    "WebsiteURL": "https://graves.house.gov",
    "FacebookURL": "https://facebook.com/RepSamGraves",
    "XURL": "https://x.com/RepSamGraves",
    "State": "MO"
  },
  {
    "FirstName": "Eric",
    "LastName": "Burlison",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6536",
    "Address": "1108 LHOB",
    "WebsiteURL": "https://burlison.house.gov",
    "FacebookURL": "https://facebook.com/RepEricBurlison",
    "XURL": "https://x.com/RepEricBurlison",
    "State": "MO"
  },
  {
    "FirstName": "Jason",
    "LastName": "Smith",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4404",
    "Address": "1011 LHOB",
    "WebsiteURL": "https://jasonsmith.house.gov",
    "FacebookURL": "https://facebook.com/RepJasonSmith",
    "XURL": "https://x.com/RepJasonSmith",
    "State": "MO"
  },
  {
    "FirstName": "Ryan",
    "LastName": "Zinke",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5628",
    "Address": "512 CHOB",
    "WebsiteURL": "https://zinke.house.gov",
    "FacebookURL": "https://facebook.com/RepRyanZinke",
    "XURL": "https://x.com/RepRyanZinke",
    "State": "MT"
  },
  {
    "FirstName": "Troy",
    "LastName": "Downing",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3211",
    "Address": "1529 LHOB",
    "WebsiteURL": "https://downing.house.gov",
    "FacebookURL": "https://facebook.com/DowningForMontana",
    "XURL": "https://x.com/TroyDowningMT",
    "State": "MT"
  },
  {
    "FirstName": "Mike",
    "LastName": "Flood",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4806",
    "Address": "343 CHOB",
    "WebsiteURL": "https://flood.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeFlood",
    "XURL": "https://x.com/USRepFlood",
    "State": "NE"
  },
  {
    "FirstName": "Don",
    "LastName": "Bacon",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4155",
    "Address": "2104 RHOB",
    "WebsiteURL": "https://bacon.house.gov",
    "FacebookURL": "https://facebook.com/RepDonBacon",
    "XURL": "https://x.com/RepDonBacon",
    "State": "NE"
  },
  {
    "FirstName": "Adrian",
    "LastName": "Smith",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6435",
    "Address": "502 CHOB",
    "WebsiteURL": "https://adriansmith.house.gov",
    "FacebookURL": "https://facebook.com/RepAdrianSmith",
    "XURL": "https://x.com/RepAdrianSmith",
    "State": "NE"
  },
  {
    "FirstName": "Dina",
    "LastName": "Titus",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5965",
    "Address": "2370 RHOB",
    "WebsiteURL": "https://titus.house.gov",
    "FacebookURL": "https://facebook.com/CongresswomanTitus",
    "XURL": "https://x.com/repdinatitus",
    "State": "NV"
  },
  {
    "FirstName": "Mark",
    "LastName": "Amodei",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6155",
    "Address": "104 CHOB",
    "WebsiteURL": "https://amodei.house.gov",
    "FacebookURL": "https://facebook.com/RepMarkAmodei",
    "XURL": "https://x.com/MarkAmodeiNV2",
    "State": "NV"
  },
  {
    "FirstName": "Susie",
    "LastName": "Lee",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3252",
    "Address": "365 CHOB",
    "WebsiteURL": "https://susielee.house.gov",
    "FacebookURL": "https://facebook.com/RepSusieLee",
    "XURL": "https://x.com/RepSusieLee",
    "State": "NV"
  },
  {
    "FirstName": "Steven",
    "LastName": "Horsford",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-9894",
    "Address": "406 CHOB",
    "WebsiteURL": "https://horsford.house.gov",
    "FacebookURL": "https://facebook.com/RepHorsford",
    "XURL": "https://x.com/RepHorsford",
    "State": "NV"
  },
  {
    "FirstName": "Chris",
    "LastName": "Pappas",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5456",
    "Address": "452 CHOB",
    "WebsiteURL": "https://pappas.house.gov",
    "FacebookURL": "https://facebook.com/MaggieGoodlanderNH",
    "XURL": "https://x.com/MaggieG603",
    "State": "NH"
  },
  {
    "FirstName": "Maggie",
    "LastName": "Goodlander",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5206",
    "Address": "223 CHOB",
    "WebsiteURL": "https://goodlander.house.gov",
    "FacebookURL": "https://facebook.com/RepChrisPappas",
    "XURL": "https://x.com/RepChrisPappas",
    "State": "NH"
  },
  {
    "FirstName": "Donald",
    "LastName": "Norcross",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6501",
    "Address": "2427 RHOB",
    "WebsiteURL": "https://norcross.house.gov",
    "FacebookURL": "https://facebook.com/RepDonaldNorcross",
    "XURL": "https://x.com/DonaldNorcross",
    "State": "NJ"
  },
  {
    "FirstName": "Jefferson",
    "LastName": "Van Drew",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6572",
    "Address": "2447 RHOB",
    "WebsiteURL": "https://vandrew.house.gov",
    "FacebookURL": "https://facebook.com/RepVanDrew",
    "XURL": "https://x.com/Congressman_JVD",
    "State": "NJ"
  },
  {
    "FirstName": "Herbert",
    "LastName": "Conaway",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4765",
    "Address": "1022 LHOB",
    "WebsiteURL": "https://conaway.house.gov",
    "FacebookURL": "https://facebook.com/HerbConaway",
    "XURL": "https://x.com/HerbConaway",
    "State": "NJ"
  },
  {
    "FirstName": "Christopher",
    "LastName": "Smith",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3765",
    "Address": "2373 RHOB",
    "WebsiteURL": "https://chrissmith.house.gov",
    "FacebookURL": "https://facebook.com/RepChrisSmith",
    "XURL": "https://x.com/RepChrisSmith",
    "State": "NJ"
  },
  {
    "FirstName": "Josh",
    "LastName": "Gottheimer",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4465",
    "Address": "106 CHOB",
    "WebsiteURL": "https://gottheimer.house.gov",
    "FacebookURL": "https://facebook.com/RepJoshG",
    "XURL": "https://x.com/RepJoshG",
    "State": "NJ"
  },
  {
    "FirstName": "Frank",
    "LastName": "Pallone",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4671",
    "Address": "2107 RHOB",
    "WebsiteURL": "https://pallone.house.gov",
    "FacebookURL": "https://facebook.com/RepFrankPallone",
    "XURL": "https://x.com/FrankPallone",
    "State": "NJ"
  },
  {
    "FirstName": "Thomas",
    "LastName": "Kean",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5361",
    "Address": "251 CHOB",
    "WebsiteURL": "https://kean.house.gov",
    "FacebookURL": "https://facebook.com/RepTomKean",
    "XURL": "https://x.com/RepTomKean",
    "State": "NJ"
  },
  {
    "FirstName": "Robert",
    "LastName": "Menendez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7919",
    "Address": "2453 RHOB",
    "WebsiteURL": "https://menendez.house.gov",
    "FacebookURL": "https://facebook.com/RepRobMenendez",
    "XURL": "https://x.com/RepMenendez",
    "State": "NJ"
  },
  {
    "FirstName": "Nellie",
    "LastName": "Pou",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5751",
    "Address": "1007 LHOB",
    "WebsiteURL": "https://pou.house.gov",
    "FacebookURL": "https://facebook.com/NelliePouNJ",
    "XURL": "https://x.com/NelliePou",
    "State": "NJ"
  },
  {
    "FirstName": "LaMonica",
    "LastName": "McIver",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3436",
    "Address": "426 CHOB",
    "WebsiteURL": "https://mciver.house.gov",
    "FacebookURL": "https://facebook.com/LaMonicaMcIver",
    "XURL": "https://x.com/LaMonicaMcIver",
    "State": "NJ"
  },
  {
    "FirstName": "Mikie",
    "LastName": "Sherrill",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5034",
    "Address": "1427 LHOB",
    "WebsiteURL": "https://sherrill.house.gov",
    "FacebookURL": "-",
    "XURL": "-",
    "State": "NJ"
  },
  {
    "FirstName": "Bonnie",
    "LastName": "Watson Coleman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5801",
    "Address": "168 CHOB",
    "WebsiteURL": "https://watsoncoleman.house.gov",
    "FacebookURL": "https://facebook.com/RepBonnie",
    "XURL": "https://x.com/RepBonnie",
    "State": "NJ"
  },
  {
    "FirstName": "Melanie",
    "LastName": "Stansbury",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6316",
    "Address": "1421 LHOB",
    "WebsiteURL": "https://stansbury.house.gov",
    "FacebookURL": "https://facebook.com/RepMelanieNM",
    "XURL": "https://x.com/Rep_Stansbury",
    "State": "NM"
  },
  {
    "FirstName": "Gabe",
    "LastName": "Vasquez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2365",
    "Address": "322 CHOB",
    "WebsiteURL": "https://vasquez.house.gov",
    "FacebookURL": "https://facebook.com/RepGabeVasquez",
    "XURL": "https://x.com/RepGabeVasquez",
    "State": "NM"
  },
  {
    "FirstName": "Teresa",
    "LastName": "Leger Fernandez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6190",
    "Address": "2417 RHOB",
    "WebsiteURL": "https://fernandez.house.gov",
    "FacebookURL": "https://facebook.com/RepTeresaLF",
    "XURL": "https://x.com/RepTeresaLF",
    "State": "NM"
  },
  {
    "FirstName": "Nick",
    "LastName": "LaLota",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3826",
    "Address": "122 CHOB",
    "WebsiteURL": "https://lalota.house.gov",
    "FacebookURL": "https://facebook.com/RepLaLota",
    "XURL": "https://x.com/RepLaLota",
    "State": "NY"
  },
  {
    "FirstName": "Andrew",
    "LastName": "Garbarino",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-7896",
    "Address": "2344 RHOB",
    "WebsiteURL": "https://garbarino.house.gov",
    "FacebookURL": "https://facebook.com/RepGarbarino",
    "XURL": "https://x.com/RepGarbarino",
    "State": "NY"
  },
  {
    "FirstName": "Thomas R.",
    "LastName": "Suozzi",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3335",
    "Address": "203 CHOB",
    "WebsiteURL": "https://suozzi.house.gov",
    "FacebookURL": "https://facebook.com/RepTomSuozzi",
    "XURL": "https://x.com/RepTomSuozzi",
    "State": "NY"
  },
  {
    "FirstName": "Laura",
    "LastName": "Gillen",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5516",
    "Address": "428 CHOB",
    "WebsiteURL": "https://gillen.house.gov",
    "FacebookURL": "https://facebook.com/LauraGillenNY",
    "XURL": "https://x.com/LauraGillen",
    "State": "NY"
  },
  {
    "FirstName": "Gregory",
    "LastName": "Meeks",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3461",
    "Address": "2310 RHOB",
    "WebsiteURL": "https://meeks.house.gov",
    "FacebookURL": "https://facebook.com/GregoryMeeksNY",
    "XURL": "https://x.com/RepGregoryMeeks",
    "State": "NY"
  },
  {
    "FirstName": "Grace",
    "LastName": "Meng",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2601",
    "Address": "2468 RHOB",
    "WebsiteURL": "https://meng.house.gov",
    "FacebookURL": "https://facebook.com/RepGraceMeng",
    "XURL": "https://x.com/RepGraceMeng",
    "State": "NY"
  },
  {
    "FirstName": "Nydia",
    "LastName": "Velazquez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2361",
    "Address": "2302 RHOB",
    "WebsiteURL": "https://velazquez.house.gov",
    "FacebookURL": "https://facebook.com/RepNydiaVelazquez",
    "XURL": "https://x.com/NydiaVelazquez",
    "State": "NY"
  },
  {
    "FirstName": "Hakeem",
    "LastName": "Jeffries",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5936",
    "Address": "2267 RHOB",
    "WebsiteURL": "https://jeffries.house.gov",
    "FacebookURL": "https://facebook.com/RepHakeemJeffries",
    "XURL": "https://x.com/RepJeffries",
    "State": "NY"
  },
  {
    "FirstName": "Yvette",
    "LastName": "Clarke",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6231",
    "Address": "2058 RHOB",
    "WebsiteURL": "https://clarke.house.gov",
    "FacebookURL": "https://facebook.com/RepYvetteClarke",
    "XURL": "https://x.com/RepYvetteClarke",
    "State": "NY"
  },
  {
    "FirstName": "Daniel",
    "LastName": "Goldman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7944",
    "Address": "245 CHOB",
    "WebsiteURL": "https://goldman.house.gov",
    "FacebookURL": "https://facebook.com/RepDanGoldman",
    "XURL": "https://x.com/RepDanGoldman",
    "State": "NY"
  },
  {
    "FirstName": "Nicole",
    "LastName": "Malliotakis",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3371",
    "Address": "1124 LHOB",
    "WebsiteURL": "https://malliotakis.house.gov",
    "FacebookURL": "https://facebook.com/RepNicoleMalliotakis",
    "XURL": "https://x.com/RepMalliotakis",
    "State": "NY"
  },
  {
    "FirstName": "Jerrold",
    "LastName": "Nadler",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5635",
    "Address": "2132 RHOB",
    "WebsiteURL": "https://nadler.house.gov",
    "FacebookURL": "https://facebook.com/RepJerryNadler",
    "XURL": "https://x.com/RepJerryNadler",
    "State": "NY"
  },
  {
    "FirstName": "Adriano",
    "LastName": "Espaillat",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4365",
    "Address": "2332 RHOB",
    "WebsiteURL": "https://espaillat.house.gov",
    "FacebookURL": "https://facebook.com/RepEspaillat",
    "XURL": "https://x.com/RepEspaillat",
    "State": "NY"
  },
  {
    "FirstName": "Alexandria",
    "LastName": "Ocasio-Cortez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3965",
    "Address": "250 CHOB",
    "WebsiteURL": "https://ocasio-cortez.house.gov",
    "FacebookURL": "https://facebook.com/RepAOC",
    "XURL": "https://x.com/RepAOC",
    "State": "NY"
  },
  {
    "FirstName": "Ritchie",
    "LastName": "Torres",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4361",
    "Address": "1414 LHOB",
    "WebsiteURL": "https://ritchietorres.house.gov",
    "FacebookURL": "https://facebook.com/RepRitchie",
    "XURL": "https://x.com/RepRitchie",
    "State": "NY"
  },
  {
    "FirstName": "George",
    "LastName": "Latimer",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2464",
    "Address": "1507 LHOB",
    "WebsiteURL": "https://latimer.house.gov",
    "FacebookURL": "https://facebook.com/GeorgeLatimerNY",
    "XURL": "https://x.com/GeorgeLatimerNY",
    "State": "NY"
  },
  {
    "FirstName": "Michael",
    "LastName": "Lawler",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6506",
    "Address": "324 CHOB",
    "WebsiteURL": "https://lawler.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeLawler",
    "XURL": "https://x.com/RepMikeLawler",
    "State": "NY"
  },
  {
    "FirstName": "Patrick",
    "LastName": "Ryan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5614",
    "Address": "1708 LHOB",
    "WebsiteURL": "https://patryan.house.gov",
    "FacebookURL": "https://facebook.com/RepPatRyanNY",
    "XURL": "https://x.com/RepPatRyanNY",
    "State": "NY"
  },
  {
    "FirstName": "Josh",
    "LastName": "Riley",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5441",
    "Address": "128 CHOB",
    "WebsiteURL": "https://riley.house.gov",
    "FacebookURL": "https://facebook.com/JoshRileyNY",
    "XURL": "https://x.com/JoshRileyNY",
    "State": "NY"
  },
  {
    "FirstName": "Paul",
    "LastName": "Tonko",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5076",
    "Address": "2269 RHOB",
    "WebsiteURL": "https://tonko.house.gov",
    "FacebookURL": "https://facebook.com/RepPaulTonko",
    "XURL": "https://x.com/RepPaulTonko",
    "State": "NY"
  },
  {
    "FirstName": "Elise",
    "LastName": "Stefanik",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4611",
    "Address": "2211 RHOB",
    "WebsiteURL": "https://stefanik.house.gov",
    "FacebookURL": "https://facebook.com/RepStefanik",
    "XURL": "https://x.com/RepStefanik",
    "State": "NY"
  },
  {
    "FirstName": "John",
    "LastName": "Mannion",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3701",
    "Address": "1516 LHOB",
    "WebsiteURL": "https://mannion.house.gov",
    "FacebookURL": "https://facebook.com/JohnMannionNY",
    "XURL": "https://x.com/JohnMannionNY",
    "State": "NY"
  },
  {
    "FirstName": "Nicholas",
    "LastName": "Langworthy",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3161",
    "Address": "422 CHOB",
    "WebsiteURL": "https://langworthy.house.gov",
    "FacebookURL": "https://facebook.com/RepLangworthy",
    "XURL": "https://x.com/RepLangworthy",
    "State": "NY"
  },
  {
    "FirstName": "Claudia",
    "LastName": "Tenney",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3665",
    "Address": "2230 RHOB",
    "WebsiteURL": "https://tenney.house.gov",
    "FacebookURL": "https://facebook.com/RepTenney",
    "XURL": "https://x.com/RepTenney",
    "State": "NY"
  },
  {
    "FirstName": "Joseph",
    "LastName": "Morelle",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3615",
    "Address": "570 CHOB",
    "WebsiteURL": "https://morelle.house.gov",
    "FacebookURL": "https://facebook.com/RepJoeMorelle",
    "XURL": "https://x.com/RepJoeMorelle",
    "State": "NY"
  },
  {
    "FirstName": "Timothy",
    "LastName": "Kennedy",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3306",
    "Address": "423 CHOB",
    "WebsiteURL": "https://kennedy.house.gov",
    "FacebookURL": "https://facebook.com/TimKennedyNY",
    "XURL": "https://x.com/SenTimKennedy",
    "State": "NY"
  },
  {
    "FirstName": "Donald",
    "LastName": "Davis",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3101",
    "Address": "1123 LHOB",
    "WebsiteURL": "https://dondavis.house.gov",
    "FacebookURL": "https://facebook.com/RepDonDavis",
    "XURL": "https://x.com/RepDonDavis",
    "State": "NC"
  },
  {
    "FirstName": "Deborah",
    "LastName": "Ross",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3032",
    "Address": "1221 LHOB",
    "WebsiteURL": "https://ross.house.gov",
    "FacebookURL": "https://facebook.com/RepDeborahRoss",
    "XURL": "https://x.com/RepDeborahRoss",
    "State": "NC"
  },
  {
    "FirstName": "Gregory",
    "LastName": "Murphy",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3415",
    "Address": "407 CHOB",
    "WebsiteURL": "https://murphy.house.gov",
    "FacebookURL": "https://facebook.com/RepGregMurphy",
    "XURL": "https://x.com/RepGregMurphy",
    "State": "NC"
  },
  {
    "FirstName": "Valerie",
    "LastName": "Foushee",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1784",
    "Address": "2452 RHOB",
    "WebsiteURL": "https://foushee.house.gov",
    "FacebookURL": "https://facebook.com/RepValerieFoushee",
    "XURL": "https://x.com/RepFoushee",
    "State": "NC"
  },
  {
    "FirstName": "Virginia",
    "LastName": "Foxx",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2071",
    "Address": "2462 RHOB",
    "WebsiteURL": "https://foxx.house.gov",
    "FacebookURL": "https://facebook.com/RepVirginiaFoxx",
    "XURL": "https://x.com/VirginiaFoxx",
    "State": "NC"
  },
  {
    "FirstName": "Addison",
    "LastName": "McDowell",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3065",
    "Address": "1032 LHOB",
    "WebsiteURL": "https://mcdowell.house.gov",
    "FacebookURL": "https://facebook.com/AddisonMcDowellNC",
    "XURL": "https://x.com/AddisonMcDowell",
    "State": "NC"
  },
  {
    "FirstName": "David",
    "LastName": "Rouzer",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2731",
    "Address": "2333 RHOB",
    "WebsiteURL": "https://rouzer.house.gov",
    "FacebookURL": "https://facebook.com/RepDavidRouzer",
    "XURL": "https://x.com/RepDavidRouzer",
    "State": "NC"
  },
  {
    "FirstName": "Mark",
    "LastName": "Harris",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-1976",
    "Address": "126 CHOB",
    "WebsiteURL": "https://markharris.house.gov",
    "FacebookURL": "https://facebook.com/MarkHarrisNC",
    "XURL": "https://x.com/MarkHarrisNC",
    "State": "NC"
  },
  {
    "FirstName": "Richard",
    "LastName": "Hudson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3715",
    "Address": "2112 RHOB",
    "WebsiteURL": "https://hudson.house.gov",
    "FacebookURL": "https://facebook.com/RepRichHudson",
    "XURL": "https://x.com/RepRichHudson",
    "State": "NC"
  },
  {
    "FirstName": "Pat",
    "LastName": "Harrigan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2576",
    "Address": "1233 LHOB",
    "WebsiteURL": "https://harrigan.house.gov",
    "FacebookURL": "https://facebook.com/PatHarriganNC",
    "XURL": "https://x.com/PatHarriganNC",
    "State": "NC"
  },
  {
    "FirstName": "Chuck",
    "LastName": "Edwards",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6401",
    "Address": "1505 LHOB",
    "WebsiteURL": "https://edwards.house.gov",
    "FacebookURL": "https://facebook.com/RepChuckEdwards",
    "XURL": "https://x.com/RepChuckEdwards",
    "State": "NC"
  },
  {
    "FirstName": "Alma",
    "LastName": "Adams",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1510",
    "Address": "2436 RHOB",
    "WebsiteURL": "https://adams.house.gov",
    "FacebookURL": "https://facebook.com/RepAlmaAdams",
    "XURL": "https://x.com/RepAdams",
    "State": "NC"
  },
  {
    "FirstName": "Brad",
    "LastName": "Knott",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4531",
    "Address": "1239 LHOB",
    "WebsiteURL": "https://knott.house.gov",
    "FacebookURL": "https://facebook.com/BradKnottNC",
    "XURL": "https://x.com/BradKnottNC",
    "State": "NC"
  },
  {
    "FirstName": "Tim",
    "LastName": "Moore",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5634",
    "Address": "1424 LHOB",
    "WebsiteURL": "https://timmoore.house.gov",
    "FacebookURL": "https://facebook.com/TimMooreNC",
    "XURL": "https://x.com/TimMooreNC",
    "State": "NC"
  },
  {
    "FirstName": "Julie",
    "LastName": "Fedorchak",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2611",
    "Address": "1607 LHOB",
    "WebsiteURL": "https://fedorchak.house.gov",
    "FacebookURL": "https://facebook.com/RickBeckerND",
    "XURL": "https://x.com/RickBeckerND",
    "State": "ND"
  },
  {
    "FirstName": "Kimberlyn",
    "LastName": "King-Hinds",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2646",
    "Address": "425 CHOB",
    "WebsiteURL": "https://king-hinds.house.gov",
    "FacebookURL": "",
    "XURL": "",
    "State": "MP"
  },
  {
    "FirstName": "Greg",
    "LastName": "Landsman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2216",
    "Address": "2244 RHOB",
    "WebsiteURL": "https://landsman.house.gov",
    "FacebookURL": "https://facebook.com/RepGregLandsman",
    "XURL": "https://x.com/RepLandsman",
    "State": "OH"
  },
  {
    "FirstName": "David",
    "LastName": "Taylor",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3164",
    "Address": "325 CHOB",
    "WebsiteURL": "https://taylor.house.gov",
    "FacebookURL": "https://facebook.com/DavidTaylorOH",
    "XURL": "https://x.com/DavidTaylorOH",
    "State": "OH"
  },
  {
    "FirstName": "Joyce",
    "LastName": "Beatty",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4324",
    "Address": "2079 RHOB",
    "WebsiteURL": "https://beatty.house.gov",
    "FacebookURL": "https://facebook.com/RepBeatty",
    "XURL": "https://x.com/RepBeatty",
    "State": "OH"
  },
  {
    "FirstName": "Jim",
    "LastName": "Jordan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2676",
    "Address": "2056 RHOB",
    "WebsiteURL": "https://jordan.house.gov",
    "FacebookURL": "https://facebook.com/RepJimJordan",
    "XURL": "https://x.com/Jim_Jordan",
    "State": "OH"
  },
  {
    "FirstName": "Robert",
    "LastName": "Latta",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6405",
    "Address": "2470 RHOB",
    "WebsiteURL": "https://latta.house.gov",
    "FacebookURL": "https://facebook.com/RepBobLatta",
    "XURL": "https://x.com/boblatta",
    "State": "OH"
  },
  {
    "FirstName": "Michael A.",
    "LastName": "Rulli",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5705",
    "Address": "421 CHOB",
    "WebsiteURL": "https://rulli.house.gov",
    "FacebookURL": "https://facebook.com/MichaelRulliOH",
    "XURL": "https://x.com/michaelrulli",
    "State": "OH"
  },
  {
    "FirstName": "Max",
    "LastName": "Miller",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3876",
    "Address": "143 CHOB",
    "WebsiteURL": "https://maxmiller.house.gov",
    "FacebookURL": "https://facebook.com/RepMaxMiller",
    "XURL": "https://x.com/RepMaxMiller",
    "State": "OH"
  },
  {
    "FirstName": "Warren",
    "LastName": "Davidson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6205",
    "Address": "2113 RHOB",
    "WebsiteURL": "https://davidson.house.gov",
    "FacebookURL": "https://facebook.com/CongressmanWarrenDavidson",
    "XURL": "https://x.com/WarrenDavidson",
    "State": "OH"
  },
  {
    "FirstName": "Marcy",
    "LastName": "Kaptur",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4146",
    "Address": "2314 RHOB",
    "WebsiteURL": "https://kaptur.house.gov",
    "FacebookURL": "https://facebook.com/RepMarcyKaptur",
    "XURL": "https://x.com/RepMarcyKaptur",
    "State": "OH"
  },
  {
    "FirstName": "Michael",
    "LastName": "Turner",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6465",
    "Address": "2183 RHOB",
    "WebsiteURL": "https://turner.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeTurner",
    "XURL": "https://x.com/RepMikeTurner",
    "State": "OH"
  },
  {
    "FirstName": "Shontel",
    "LastName": "Brown",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7032",
    "Address": "2455 RHOB",
    "WebsiteURL": "https://shontelbrown.house.gov",
    "FacebookURL": "https://facebook.com/RepShontelBrown",
    "XURL": "https://x.com/RepShontelBrown",
    "State": "OH"
  },
  {
    "FirstName": "Troy",
    "LastName": "Balderson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5355",
    "Address": "2429 RHOB",
    "WebsiteURL": "https://balderson.house.gov",
    "FacebookURL": "https://facebook.com/RepTroyBalderson",
    "XURL": "https://x.com/RepTroyBalderson",
    "State": "OH"
  },
  {
    "FirstName": "Emilia",
    "LastName": "Sykes",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6265",
    "Address": "1217 LHOB",
    "WebsiteURL": "https://sykes.house.gov",
    "FacebookURL": "https://facebook.com/RepEmiliaSykes",
    "XURL": "https://x.com/RepEmiliaSykes",
    "State": "OH"
  },
  {
    "FirstName": "David",
    "LastName": "Joyce",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5731",
    "Address": "2065 RHOB",
    "WebsiteURL": "https://joyce.house.gov",
    "FacebookURL": "https://facebook.com/RepDavidJoyce",
    "XURL": "https://x.com/RepDavidJoyce",
    "State": "OH"
  },
  {
    "FirstName": "Mike",
    "LastName": "Carey",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2015",
    "Address": "1433 LHOB",
    "WebsiteURL": "https://carey.house.gov",
    "FacebookURL": "https://facebook.com/RepMikeCarey",
    "XURL": "https://x.com/RepMikeCarey",
    "State": "OH"
  },
  {
    "FirstName": "Kevin",
    "LastName": "Hern",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2211",
    "Address": "171 CHOB",
    "WebsiteURL": "https://hern.house.gov",
    "FacebookURL": "https://facebook.com/RepKevinHern",
    "XURL": "https://x.com/RepKevinHern",
    "State": "OK"
  },
  {
    "FirstName": "Josh",
    "LastName": "Brecheen",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2701",
    "Address": "351 CHOB",
    "WebsiteURL": "https://brecheen.house.gov",
    "FacebookURL": "https://facebook.com/RepJoshBrecheen",
    "XURL": "https://x.com/RepEliCrane",
    "State": "OK"
  },
  {
    "FirstName": "Frank",
    "LastName": "Lucas",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5565",
    "Address": "2405 RHOB",
    "WebsiteURL": "https://lucas.house.gov",
    "FacebookURL": "https://facebook.com/RepFrankLucas",
    "XURL": "https://x.com/RepFrankLucas",
    "State": "OK"
  },
  {
    "FirstName": "Tom",
    "LastName": "Cole",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6165",
    "Address": "2207 RHOB",
    "WebsiteURL": "https://cole.house.gov",
    "FacebookURL": "https://facebook.com/RepTomCole",
    "XURL": "https://x.com/TomColeOK04",
    "State": "OK"
  },
  {
    "FirstName": "Stephanie",
    "LastName": "Bice",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2132",
    "Address": "2402 RHOB",
    "WebsiteURL": "https://bice.house.gov",
    "FacebookURL": "https://facebook.com/RepStephanieBice",
    "XURL": "https://x.com/RepBice",
    "State": "OK"
  },
  {
    "FirstName": "Suzanne",
    "LastName": "Bonamici",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-0855",
    "Address": "2231 RHOB",
    "WebsiteURL": "https://bonamici.house.gov",
    "FacebookURL": "https://facebook.com/RepSuzanneBonamici",
    "XURL": "https://x.com/RepBonamici",
    "State": "OR"
  },
  {
    "FirstName": "Cliff",
    "LastName": "Bentz",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6730",
    "Address": "409 CHOB",
    "WebsiteURL": "https://bentz.house.gov",
    "FacebookURL": "https://facebook.com/RepCliffBentz",
    "XURL": "https://x.com/RepBentz",
    "State": "OR"
  },
  {
    "FirstName": "Maxine",
    "LastName": "Dexter",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4811",
    "Address": "1207 LHOB",
    "WebsiteURL": "https://dexter.house.gov",
    "FacebookURL": "https://facebook.com/MaxineDexterOR",
    "XURL": "https://x.com/MaxineDexter",
    "State": "OR"
  },
  {
    "FirstName": "Val",
    "LastName": "Hoyle",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6416",
    "Address": "1620 LHOB",
    "WebsiteURL": "https://hoyle.house.gov",
    "FacebookURL": "https://facebook.com/RepValHoyle",
    "XURL": "https://x.com/RepValHoyle",
    "State": "OR"
  },
  {
    "FirstName": "Janelle",
    "LastName": "Bynum",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5711",
    "Address": "1508 LHOB",
    "WebsiteURL": "https://bynum.house.gov",
    "FacebookURL": "https://facebook.com/JanelleBynumOR",
    "XURL": "https://x.com/janellebynum",
    "State": "OR"
  },
  {
    "FirstName": "Andrea",
    "LastName": "Salinas",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5643",
    "Address": "403 CHOB",
    "WebsiteURL": "https://salinas.house.gov",
    "FacebookURL": "https://facebook.com/RepAndreaSalinas",
    "XURL": "https://x.com/RepSalinas",
    "State": "OR"
  },
  {
    "FirstName": "Brian",
    "LastName": "Fitzpatrick",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4276",
    "Address": "271 CHOB",
    "WebsiteURL": "https://fitzpatrick.house.gov",
    "FacebookURL": "https://facebook.com/RepBrianFitzpatrick",
    "XURL": "https://x.com/RepBrianFitz",
    "State": "PA"
  },
  {
    "FirstName": "Brendan",
    "LastName": "Boyle",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6111",
    "Address": "1502 LHOB",
    "WebsiteURL": "https://boyle.house.gov",
    "FacebookURL": "https://facebook.com/RepBrendanBoyle",
    "XURL": "https://x.com/RepBrendanBoyle",
    "State": "PA"
  },
  {
    "FirstName": "Dwight",
    "LastName": "Evans",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4001",
    "Address": "1105 LHOB",
    "WebsiteURL": "https://evans.house.gov",
    "FacebookURL": "https://facebook.com/RepDwightEvans",
    "XURL": "https://x.com/RepDwightEvans",
    "State": "PA"
  },
  {
    "FirstName": "Madeleine",
    "LastName": "Dean",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4731",
    "Address": "150 CHOB",
    "WebsiteURL": "https://dean.house.gov",
    "FacebookURL": "https://facebook.com/RepMadeleineDean",
    "XURL": "https://x.com/RepDean",
    "State": "PA"
  },
  {
    "FirstName": "Mary Gay",
    "LastName": "Scanlon",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2011",
    "Address": "1214 LHOB",
    "WebsiteURL": "https://scanlon.house.gov",
    "FacebookURL": "https://facebook.com/RepMaryGayScanlon",
    "XURL": "https://x.com/RepMGS",
    "State": "PA"
  },
  {
    "FirstName": "Chrissy",
    "LastName": "Houlahan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4315",
    "Address": "1727 LHOB",
    "WebsiteURL": "https://houlahan.house.gov",
    "FacebookURL": "https://facebook.com/RepChrissyHoulahan",
    "XURL": "https://x.com/RepHoulahan",
    "State": "PA"
  },
  {
    "FirstName": "Ryan",
    "LastName": "Mackenzie",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6411",
    "Address": "121 CHOB",
    "WebsiteURL": "https://mackenzie.house.gov",
    "FacebookURL": "https://facebook.com/RyanMackenziePA",
    "XURL": "https://x.com/RyanMackenzie",
    "State": "PA"
  },
  {
    "FirstName": "Robert",
    "LastName": "Bresnahan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5546",
    "Address": "1133 LHOB",
    "WebsiteURL": "https://bresnahan.house.gov",
    "FacebookURL": "https://facebook.com/RepMattCartwright",
    "XURL": "https://x.com/RepCartwright",
    "State": "PA"
  },
  {
    "FirstName": "Daniel",
    "LastName": "Meuser",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6511",
    "Address": "350 CHOB",
    "WebsiteURL": "https://meuser.house.gov",
    "FacebookURL": "https://facebook.com/RepDanMeuser",
    "XURL": "https://x.com/RepMeuser",
    "State": "PA"
  },
  {
    "FirstName": "Scott",
    "LastName": "Perry",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5836",
    "Address": "2160 RHOB",
    "WebsiteURL": "https://perry.house.gov",
    "FacebookURL": "https://facebook.com/RepScottPerry",
    "XURL": "https://x.com/RepScottPerry",
    "State": "PA"
  },
  {
    "FirstName": "Lloyd",
    "LastName": "Smucker",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2411",
    "Address": "302 CHOB",
    "WebsiteURL": "https://smucker.house.gov",
    "FacebookURL": "https://facebook.com/RepSmucker",
    "XURL": "https://x.com/RepSmucker",
    "State": "PA"
  },
  {
    "FirstName": "Summer",
    "LastName": "Lee",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2135",
    "Address": "2437 RHOB",
    "WebsiteURL": "https://summerlee.house.gov",
    "FacebookURL": "https://facebook.com/RepSummerLee",
    "XURL": "https://x.com/RepSummerLee",
    "State": "PA"
  },
  {
    "FirstName": "John",
    "LastName": "Joyce",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2431",
    "Address": "2102 RHOB",
    "WebsiteURL": "https://johnjoyce.house.gov",
    "FacebookURL": "https://facebook.com/RepJohnJoyce",
    "XURL": "https://x.com/RepJohnJoyce",
    "State": "PA"
  },
  {
    "FirstName": "Guy",
    "LastName": "Reschenthaler",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2065",
    "Address": "2209 RHOB",
    "WebsiteURL": "https://reschenthaler.house.gov",
    "FacebookURL": "https://facebook.com/RepReschenthaler",
    "XURL": "https://x.com/GReschenthaler",
    "State": "PA"
  },
  {
    "FirstName": "Glenn",
    "LastName": "Thompson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5121",
    "Address": "400 CHOB",
    "WebsiteURL": "https://thompson.house.gov",
    "FacebookURL": "https://facebook.com/RepGlennThompson",
    "XURL": "https://x.com/CongressmanGT",
    "State": "PA"
  },
  {
    "FirstName": "Mike",
    "LastName": "Kelly",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5406",
    "Address": "1707 LHOB",
    "WebsiteURL": "https://kelly.house.gov",
    "FacebookURL": "https://facebook.com/MikeKellyPA",
    "XURL": "https://x.com/MikeKellyPA",
    "State": "PA"
  },
  {
    "FirstName": "Christopher",
    "LastName": "Deluzio",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2301",
    "Address": "1222 LHOB",
    "WebsiteURL": "https://deluzio.house.gov",
    "FacebookURL": "https://facebook.com/RepDeluzio",
    "XURL": "https://x.com/RepDeluzio",
    "State": "PA"
  },
  {
    "FirstName": "Pablo",
    "LastName": "Hernandez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2615",
    "Address": "1419 LHOB",
    "WebsiteURL": "https://hernandez.house.gov",
    "FacebookURL": "",
    "XURL": "",
    "State": "PR"
  },
  {
    "FirstName": "Gabe",
    "LastName": "Amo",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4911",
    "Address": "1119 LHOB",
    "WebsiteURL": "https://amo.house.gov",
    "FacebookURL": "https://facebook.com/RepGabeAmo",
    "XURL": "https://x.com/RepGabeAmo",
    "State": "RI"
  },
  {
    "FirstName": "Seth",
    "LastName": "Magaziner",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2735",
    "Address": "252 CHOB",
    "WebsiteURL": "https://magaziner.house.gov",
    "FacebookURL": "https://facebook.com/RepSethMagaziner",
    "XURL": "https://x.com/RepSethMagaziner",
    "State": "RI"
  },
  {
    "FirstName": "Nancy",
    "LastName": "Mace",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3176",
    "Address": "1728 LHOB",
    "WebsiteURL": "https://mace.house.gov",
    "FacebookURL": "https://facebook.com/RepNancyMace",
    "XURL": "https://x.com/RepNancyMace",
    "State": "SC"
  },
  {
    "FirstName": "Joe",
    "LastName": "Wilson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2452",
    "Address": "1436 LHOB",
    "WebsiteURL": "https://joewilson.house.gov",
    "FacebookURL": "https://facebook.com/JoeWilson",
    "XURL": "https://x.com/RepJoeWilson",
    "State": "SC"
  },
  {
    "FirstName": "Sheri",
    "LastName": "Biggs",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5301",
    "Address": "1530 LHOB",
    "WebsiteURL": "https://sheribiggs.house.gov",
    "FacebookURL": "https://facebook.com/SheriBiggsSC",
    "XURL": "https://x.com/SheriBiggsSC",
    "State": "SC"
  },
  {
    "FirstName": "William",
    "LastName": "Timmons",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6030",
    "Address": "267 CHOB",
    "WebsiteURL": "https://timmons.house.gov",
    "FacebookURL": "https://facebook.com/RepTimmons",
    "XURL": "https://x.com/RepTimmons",
    "State": "SC"
  },
  {
    "FirstName": "Ralph",
    "LastName": "Norman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5501",
    "Address": "569 CHOB",
    "WebsiteURL": "https://norman.house.gov",
    "FacebookURL": "https://facebook.com/RepRalphNorman",
    "XURL": "https://x.com/RepRalphNorman",
    "State": "SC"
  },
  {
    "FirstName": "James",
    "LastName": "Clyburn",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3315",
    "Address": "274 CHOB",
    "WebsiteURL": "https://clyburn.house.gov",
    "FacebookURL": "https://facebook.com/RepJamesClyburn",
    "XURL": "https://x.com/RepJamesClyburn",
    "State": "SC"
  },
  {
    "FirstName": "Russell",
    "LastName": "Fry",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-9895",
    "Address": "345 CHOB",
    "WebsiteURL": "https://fry.house.gov",
    "FacebookURL": "https://facebook.com/RepRussellFry",
    "XURL": "https://x.com/RepRussellFry",
    "State": "SC"
  },
  {
    "FirstName": "Dusty",
    "LastName": "Johnson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2801",
    "Address": "1714 LHOB",
    "WebsiteURL": "https://dustyjohnson.house.gov",
    "FacebookURL": "https://facebook.com/RepDustyJohnson",
    "XURL": "https://x.com/RepDustyJohnson",
    "State": "SC"
  },
  {
    "FirstName": "Diana",
    "LastName": "Harshbarger",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6356",
    "Address": "167 CHOB",
    "WebsiteURL": "https://harshbarger.house.gov",
    "FacebookURL": "https://facebook.com/RepHarsbarger",
    "XURL": "https://x.com/RepHarshbarger",
    "State": "TN"
  },
  {
    "FirstName": "Tim",
    "LastName": "Burchett",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5435",
    "Address": "1122 LHOB",
    "WebsiteURL": "https://burchett.house.gov",
    "FacebookURL": "https://facebook.com/RepTimBurchett",
    "XURL": "https://x.com/TimBurchett",
    "State": "TN"
  },
  {
    "FirstName": "Charles",
    "LastName": "Fleischmann",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3271",
    "Address": "2187 RHOB",
    "WebsiteURL": "https://fleischmann.house.gov",
    "FacebookURL": "https://facebook.com/RepChuck",
    "XURL": "https://x.com/RepChuck",
    "State": "TN"
  },
  {
    "FirstName": "Scott",
    "LastName": "DesJarlais",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6831",
    "Address": "2304 RHOB",
    "WebsiteURL": "https://desjarlais.house.gov",
    "FacebookURL": "https://facebook.com/RepDesJarlais",
    "XURL": "https://x.com/DesJarlaisTN04",
    "State": "TN"
  },
  {
    "FirstName": "Andrew",
    "LastName": "Ogles",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4311",
    "Address": "151 CHOB",
    "WebsiteURL": "https://ogles.house.gov",
    "FacebookURL": "https://facebook.com/RepAndyOgles",
    "XURL": "https://x.com/RepAndyOgles",
    "State": "TN"
  },
  {
    "FirstName": "John",
    "LastName": "Rose",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4231",
    "Address": "2238 RHOB",
    "WebsiteURL": "https://johnrose.house.gov",
    "FacebookURL": "https://facebook.com/RepJohnRose",
    "XURL": "https://x.com/RepJohnRose",
    "State": "TN"
  },
  {
    "FirstName": "Mark E.- Vacancy",
    "LastName": "Green",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2811",
    "Address": "2446 RHOB",
    "WebsiteURL": "https://clerk.house.govMembers#Vacancies",
    "FacebookURL": "https://facebook.com/RepMarkGreen",
    "XURL": "https://x.com/RepMarkGreen",
    "State": "TN"
  },
  {
    "FirstName": "David",
    "LastName": "Kustoff",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4714",
    "Address": "560 CHOB",
    "WebsiteURL": "https://kustoff.house.gov",
    "FacebookURL": "https://facebook.com/RepDavidKustoff",
    "XURL": "https://x.com/RepDavidKustoff",
    "State": "TN"
  },
  {
    "FirstName": "Steve",
    "LastName": "Cohen",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3265",
    "Address": "2268 RHOB",
    "WebsiteURL": "https://cohen.house.gov",
    "FacebookURL": "https://facebook.com/CongressmanSteveCohen",
    "XURL": "https://x.com/RepSteveCohen",
    "State": "TN"
  },
  {
    "FirstName": "Nathaniel",
    "LastName": "Moran",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3035",
    "Address": "1605 LHOB",
    "WebsiteURL": "https://moran.house.gov",
    "FacebookURL": "https://facebook.com/RepNathanielMoran",
    "XURL": "https://x.com/RepMoran",
    "State": "TX"
  },
  {
    "FirstName": "Dan",
    "LastName": "Crenshaw",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6565",
    "Address": "248 CHOB",
    "WebsiteURL": "https://crenshaw.house.gov",
    "FacebookURL": "https://facebook.com/RepDanCrenshaw",
    "XURL": "https://x.com/RepDanCrenshaw",
    "State": "TX"
  },
  {
    "FirstName": "Keith",
    "LastName": "Self",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4201",
    "Address": "1030 LHOB",
    "WebsiteURL": "https://keithself.house.gov",
    "FacebookURL": "https://facebook.com/RepKeithSelf",
    "XURL": "https://x.com/RepKeithSelf",
    "State": "TX"
  },
  {
    "FirstName": "Pat",
    "LastName": "Fallon",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6673",
    "Address": "2416 RHOB",
    "WebsiteURL": "https://fallon.house.gov",
    "FacebookURL": "https://facebook.com/RepPatFallon",
    "XURL": "https://x.com/RepPatFallon",
    "State": "TX"
  },
  {
    "FirstName": "Lance",
    "LastName": "Gooden",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3484",
    "Address": "2431 RHOB",
    "WebsiteURL": "https://gooden.house.gov",
    "FacebookURL": "https://facebook.com/RepLanceGooden",
    "XURL": "https://x.com/RepLanceGooden",
    "State": "TX"
  },
  {
    "FirstName": "Jake",
    "LastName": "Ellzey",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2002",
    "Address": "1721 LHOB",
    "WebsiteURL": "https://ellzey.house.gov",
    "FacebookURL": "https://facebook.com/RepJakeEllzey",
    "XURL": "https://x.com/RepEllzey",
    "State": "TX"
  },
  {
    "FirstName": "Lizzie",
    "LastName": "Fletcher",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2571",
    "Address": "2004 RHOB",
    "WebsiteURL": "https://fletcher.house.gov",
    "FacebookURL": "https://facebook.com/RepLizzieFletcher",
    "XURL": "https://x.com/RepLizzieF",
    "State": "TX"
  },
  {
    "FirstName": "Morgan",
    "LastName": "Luttrell",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4901",
    "Address": "444 CHOB",
    "WebsiteURL": "https://luttrell.house.gov",
    "FacebookURL": "https://facebook.com/RepMorganLuttrell",
    "XURL": "https://x.com/RepLuttrell",
    "State": "TX"
  },
  {
    "FirstName": "Al",
    "LastName": "Green",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7508",
    "Address": "2347 RHOB",
    "WebsiteURL": "https://algreen.house.gov",
    "FacebookURL": "https://facebook.com/repalgreen",
    "XURL": "https://x.com/RepAlGreen",
    "State": "TX"
  },
  {
    "FirstName": "Michael",
    "LastName": "McCaul",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2401",
    "Address": "2300 RHOB",
    "WebsiteURL": "https://mccaul.house.gov",
    "FacebookURL": "https://facebook.com/RepMichaelMcCaul",
    "XURL": "https://x.com/RepMcCaul",
    "State": "TX"
  },
  {
    "FirstName": "August",
    "LastName": "Pfluger",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3605",
    "Address": "2202 RHOB",
    "WebsiteURL": "https://pfluger.house.gov",
    "FacebookURL": "https://facebook.com/RepPfluger",
    "XURL": "https://x.com/RepPfluger",
    "State": "TX"
  },
  {
    "FirstName": "Craig",
    "LastName": "Goldman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5071",
    "Address": "1716 LHOB",
    "WebsiteURL": "https://craiggoldman.house.gov",
    "FacebookURL": "https://facebook.com/CraigGoldmanTX",
    "XURL": "https://x.com/CraigGoldmanTX",
    "State": "TX"
  },
  {
    "FirstName": "Ronny",
    "LastName": "Jackson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3706",
    "Address": "125 CHOB",
    "WebsiteURL": "https://jackson.house.gov",
    "FacebookURL": "https://facebook.com/RepRonnyJackson",
    "XURL": "https://x.com/RepRonnyJackson",
    "State": "TX"
  },
  {
    "FirstName": "Randy",
    "LastName": "Weber",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2831",
    "Address": "107 CHOB",
    "WebsiteURL": "https://weber.house.gov",
    "FacebookURL": "https://facebook.com/RepRandyWeber",
    "XURL": "https://x.com/TXRandy14",
    "State": "TX"
  },
  {
    "FirstName": "Monica",
    "LastName": "De La Cruz",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-9901",
    "Address": "1415 LHOB",
    "WebsiteURL": "https://delacruz.house.gov",
    "FacebookURL": "https://facebook.com/RepMonicaDeLaCruz",
    "XURL": "https://x.com/RepMonicaDLC",
    "State": "TX"
  },
  {
    "FirstName": "Veronica",
    "LastName": "Escobar",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4831",
    "Address": "2448 RHOB",
    "WebsiteURL": "https://escobar.house.gov",
    "FacebookURL": "https://facebook.com/RepEscobar",
    "XURL": "https://x.com/RepEscobar",
    "State": "TX"
  },
  {
    "FirstName": "Pete",
    "LastName": "Sessions",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6105",
    "Address": "2204 RHOB",
    "WebsiteURL": "https://sessions.house.gov",
    "FacebookURL": "https://facebook.com/PeteSessions",
    "XURL": "https://x.com/PeteSessions",
    "State": "TX"
  },
  {
    "FirstName": "Sylvester- Vacancy",
    "LastName": "Turner",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3816",
    "Address": "1318 LHOB",
    "WebsiteURL": "https://clerk.house.govmembers/TX18/vacancy",
    "FacebookURL": "https://facebook.com/SylvesterTurner",
    "XURL": "https://x.com/SylvesterTurner",
    "State": "TX"
  },
  {
    "FirstName": "Jodey",
    "LastName": "Arrington",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4005",
    "Address": "1111 LHOB",
    "WebsiteURL": "https://arrington.house.gov",
    "FacebookURL": "https://facebook.com/RepArrington",
    "XURL": "https://x.com/RepArrington",
    "State": "TX"
  },
  {
    "FirstName": "Joaquin",
    "LastName": "Castro",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3236",
    "Address": "2241 RHOB",
    "WebsiteURL": "https://castro.house.gov",
    "FacebookURL": "https://facebook.com/joaquincastrotx",
    "XURL": "https://x.com/JoaquinCastrotx",
    "State": "TX"
  },
  {
    "FirstName": "Chip",
    "LastName": "Roy",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4236",
    "Address": "103 CHOB",
    "WebsiteURL": "https://roy.house.gov",
    "FacebookURL": "https://facebook.com/RepChipRoy",
    "XURL": "https://x.com/RepChipRoy",
    "State": "TX"
  },
  {
    "FirstName": "Troy",
    "LastName": "Nehls",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5951",
    "Address": "1104 LHOB",
    "WebsiteURL": "https://nehls.house.gov",
    "FacebookURL": "https://facebook.com/RepTroyNehls",
    "XURL": "https://x.com/RepTroyNehls",
    "State": "TX"
  },
  {
    "FirstName": "Tony",
    "LastName": "Gonzales",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4511",
    "Address": "2239 RHOB",
    "WebsiteURL": "https://gonzales.house.gov",
    "FacebookURL": "https://facebook.com/RepTonyGonzales",
    "XURL": "https://x.com/RepTonyGonzales",
    "State": "TX"
  },
  {
    "FirstName": "Beth",
    "LastName": "Van Duyne",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-6605",
    "Address": "1725 LHOB",
    "WebsiteURL": "https://vanduyne.house.gov",
    "FacebookURL": "https://facebook.com/RepBethVanDuyne",
    "XURL": "https://x.com/RepBethVanDuyne",
    "State": "TX"
  },
  {
    "FirstName": "Roger",
    "LastName": "Williams",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-9896",
    "Address": "2336 RHOB",
    "WebsiteURL": "https://williams.house.gov",
    "FacebookURL": "https://facebook.com/RepRogerWilliams",
    "XURL": "https://x.com/RepRWilliams",
    "State": "TX"
  },
  {
    "FirstName": "Brandon",
    "LastName": "Gill",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-7772",
    "Address": "1305 LHOB",
    "WebsiteURL": "https://gill.house.gov",
    "FacebookURL": "https://facebook.com/BrandonGillTX",
    "XURL": "https://x.com/BrandonGillTX",
    "State": "TX"
  },
  {
    "FirstName": "Michael",
    "LastName": "Cloud",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-7742",
    "Address": "304 CHOB",
    "WebsiteURL": "https://cloud.house.gov",
    "FacebookURL": "https://facebook.com/RepMichaelCloud",
    "XURL": "https://x.com/RepCloudTX",
    "State": "TX"
  },
  {
    "FirstName": "Henry",
    "LastName": "Cuellar",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1640",
    "Address": "2308 RHOB",
    "WebsiteURL": "https://cuellar.house.gov",
    "FacebookURL": "https://facebook.com/rep_henry_cuellar",
    "XURL": "https://x.com/RepCuellar",
    "State": "TX"
  },
  {
    "FirstName": "Sylvia",
    "LastName": "Garcia",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1688",
    "Address": "2419 RHOB",
    "WebsiteURL": "https://sylviagarcia.house.gov",
    "FacebookURL": "https://facebook.com/RepSylviaGarcia",
    "XURL": "https://x.com/RepSylviaGarcia",
    "State": "TX"
  },
  {
    "FirstName": "Jasmine",
    "LastName": "Crockett",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8885",
    "Address": "1616 LHOB",
    "WebsiteURL": "https://crockett.house.gov",
    "FacebookURL": "https://facebook.com/RepJasmineCrockett",
    "XURL": "https://x.com/RepJasmine",
    "State": "TX"
  },
  {
    "FirstName": "John",
    "LastName": "Carter",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3864",
    "Address": "2208 RHOB",
    "WebsiteURL": "https://carter.house.gov",
    "FacebookURL": "https://facebook.com/JudgeJohnCarter",
    "XURL": "https://x.com/JudgeJohnCarter",
    "State": "TX"
  },
  {
    "FirstName": "Julie",
    "LastName": "Johnson",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2231",
    "Address": "221 CHOB",
    "WebsiteURL": "https://juliejohnson.house.gov",
    "FacebookURL": "https://facebook.com/JulieJohnsonTX",
    "XURL": "https://x.com/juliejohnsonf1",
    "State": "TX"
  },
  {
    "FirstName": "Marc",
    "LastName": "Veasey",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-9897",
    "Address": "2186 RHOB",
    "WebsiteURL": "https://veasey.house.gov",
    "FacebookURL": "https://facebook.com/RepMarcVeasey",
    "XURL": "https://x.com/RepVeasey",
    "State": "TX"
  },
  {
    "FirstName": "Vicente",
    "LastName": "Gonzalez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2531",
    "Address": "1201 LHOB",
    "WebsiteURL": "https://gonzalez.house.gov",
    "FacebookURL": "https://facebook.com/RepVicenteGonzalez",
    "XURL": "https://x.com/RepVicente",
    "State": "TX"
  },
  {
    "FirstName": "Greg",
    "LastName": "Casar",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5645",
    "Address": "446 CHOB",
    "WebsiteURL": "https://casar.house.gov",
    "FacebookURL": "https://facebook.com/RepCasar",
    "XURL": "https://x.com/RepCasar",
    "State": "TX"
  },
  {
    "FirstName": "Brian",
    "LastName": "Babin",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-1555",
    "Address": "2236 RHOB",
    "WebsiteURL": "https://babin.house.gov",
    "FacebookURL": "https://facebook.com/RepBrianBabin",
    "XURL": "https://x.com/RepBrianBabin",
    "State": "TX"
  },
  {
    "FirstName": "Lloyd",
    "LastName": "Doggett",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4865",
    "Address": "2307 RHOB",
    "WebsiteURL": "https://doggett.house.gov",
    "FacebookURL": "https://facebook.com/RepLloydDoggett",
    "XURL": "https://x.com/RepLloydDoggett",
    "State": "TX"
  },
  {
    "FirstName": "Wesley",
    "LastName": "Hunt",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5646",
    "Address": "1520 LHOB",
    "WebsiteURL": "https://hunt.house.gov",
    "FacebookURL": "https://facebook.com/RepWesleyHunt",
    "XURL": "https://x.com/RepWesleyHunt",
    "State": "TX"
  },
  {
    "FirstName": "Blake",
    "LastName": "Moore",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-0453",
    "Address": "1131 LHOB",
    "WebsiteURL": "https://blakemoore.house.gov",
    "FacebookURL": "https://facebook.com/RepBlakeMoore",
    "XURL": "https://x.com/RepBlakeMoore",
    "State": "UT"
  },
  {
    "FirstName": "Celeste",
    "LastName": "Maloy",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-9730",
    "Address": "249 CHOB",
    "WebsiteURL": "https://maloy.house.gov",
    "FacebookURL": "https://facebook.com/RepCelesteMaloy",
    "XURL": "https://x.com/RepCelesteMaloy",
    "State": "UT"
  },
  {
    "FirstName": "Mike",
    "LastName": "Kennedy",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-7751",
    "Address": "1626 LHOB",
    "WebsiteURL": "https://mikekennedy.house.gov",
    "FacebookURL": "https://facebook.com/MikeKennedyUT",
    "XURL": "https://x.com/MikeKennedyUT",
    "State": "UT"
  },
  {
    "FirstName": "Burgess",
    "LastName": "Owens",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3011",
    "Address": "309 CHOB",
    "WebsiteURL": "https://owens.house.gov",
    "FacebookURL": "https://facebook.com/RepBurgessOwens",
    "XURL": "https://x.com/RepBurgessOwens",
    "State": "UT"
  },
  {
    "FirstName": "Becca",
    "LastName": "Balint",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4115",
    "Address": "1510 LHOB",
    "WebsiteURL": "https://balint.house.gov",
    "FacebookURL": "https://facebook.com/RepBeccaBalint",
    "XURL": "https://x.com/RepBeccaB",
    "State": "VT"
  },
  {
    "FirstName": "Robert",
    "LastName": "Wittman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4261",
    "Address": "2055 RHOB",
    "WebsiteURL": "https://wittman.house.gov",
    "FacebookURL": "https://facebook.com/RepRobWittman",
    "XURL": "https://x.com/RobWittman",
    "State": "VA"
  },
  {
    "FirstName": "Jennifer",
    "LastName": "Kiggans",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4215",
    "Address": "152 CHOB",
    "WebsiteURL": "https://kiggans.house.gov",
    "FacebookURL": "https://facebook.com/RepJenKiggans",
    "XURL": "https://x.com/RepJenKiggans",
    "State": "VA"
  },
  {
    "FirstName": "Robert",
    "LastName": "Scott",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8351",
    "Address": "2328 RHOB",
    "WebsiteURL": "https://bobbyscott.house.gov",
    "FacebookURL": "https://facebook.com/RepBobbyScott",
    "XURL": "https://x.com/BobbyScott",
    "State": "VA"
  },
  {
    "FirstName": "Jennifer",
    "LastName": "McClellan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6365",
    "Address": "1628 LHOB",
    "WebsiteURL": "https://mcclellan.house.gov",
    "FacebookURL": "https://facebook.com/RepMcClellan",
    "XURL": "https://x.com/RepMcClellan",
    "State": "VA"
  },
  {
    "FirstName": "John",
    "LastName": "McGuire",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-4711",
    "Address": "1013 LHOB",
    "WebsiteURL": "https://mcguire.house.gov",
    "FacebookURL": "https://facebook.com/JohnMcGuireVA",
    "XURL": "https://x.com/JohnMcGuireVA",
    "State": "VA"
  },
  {
    "FirstName": "Ben",
    "LastName": "Cline",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5431",
    "Address": "2443 RHOB",
    "WebsiteURL": "https://cline.house.gov",
    "FacebookURL": "https://facebook.com/RepBenCline",
    "XURL": "https://x.com/RepBenCline",
    "State": "VA"
  },
  {
    "FirstName": "Eugene",
    "LastName": "Vindman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2815",
    "Address": "1005 LHOB",
    "WebsiteURL": "https://vindman.house.gov",
    "FacebookURL": "https://facebook.com/EugeneVindman",
    "XURL": "https://x.com/YVindman",
    "State": "VA"
  },
  {
    "FirstName": "Donald",
    "LastName": "Beyer",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4376",
    "Address": "1226 LHOB",
    "WebsiteURL": "https://beyer.house.gov",
    "FacebookURL": "https://facebook.com/RepDonBeyer",
    "XURL": "https://x.com/RepDonBeyer",
    "State": "VA"
  },
  {
    "FirstName": "H.",
    "LastName": "Griffith",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3861",
    "Address": "2110 RHOB",
    "WebsiteURL": "https://morgangriffith.house.gov",
    "FacebookURL": "https://facebook.com/RepMorganGriffith",
    "XURL": "https://x.com/RepMGriffith",
    "State": "VA"
  },
  {
    "FirstName": "Suhas",
    "LastName": "Subramanyam",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5136",
    "Address": "1009 LHOB",
    "WebsiteURL": "https://subramanyam.house.gov",
    "FacebookURL": "https://facebook.com/SuhasSubramanyam",
    "XURL": "https://x.com/SuhasSubramanya",
    "State": "VA"
  },
  {
    "FirstName": "James",
    "LastName": "Walkinshaw",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1492",
    "Address": "2265 RHOB",
    "WebsiteURL": "https://walkinshaw.house.gov",
    "FacebookURL": "",
    "XURL": "",
    "State": "VA"
  },
  {
    "FirstName": "Stacey",
    "LastName": "Plaskett",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-1790",
    "Address": "2059 RHOB",
    "WebsiteURL": "https://plaskett.house.gov",
    "FacebookURL": "",
    "XURL": "",
    "State": "VI"
  },
  {
    "FirstName": "Suzan",
    "LastName": "DelBene",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-6311",
    "Address": "2311 RHOB",
    "WebsiteURL": "https://delbene.house.gov",
    "FacebookURL": "https://facebook.com/RepDelBene",
    "XURL": "https://x.com/RepDelBene",
    "State": "WA"
  },
  {
    "FirstName": "Rick",
    "LastName": "Larsen",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2605",
    "Address": "2163 RHOB",
    "WebsiteURL": "https://larsen.house.gov",
    "FacebookURL": "https://facebook.com/RepRickLarsen",
    "XURL": "https://x.com/RepRickLarsen",
    "State": "WA"
  },
  {
    "FirstName": "Marie",
    "LastName": "Perez",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3536",
    "Address": "1431 LHOB",
    "WebsiteURL": "https://gluesenkampperez.house.gov",
    "FacebookURL": "https://facebook.com/RepMGP",
    "XURL": "https://x.com/RepMGP",
    "State": "WA"
  },
  {
    "FirstName": "Dan",
    "LastName": "Newhouse",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5816",
    "Address": "460 CHOB",
    "WebsiteURL": "https://newhouse.house.gov",
    "FacebookURL": "https://facebook.com/RepDanNewhouse",
    "XURL": "https://x.com/RepNewhouse",
    "State": "WA"
  },
  {
    "FirstName": "Michael",
    "LastName": "Baumgartner",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2006",
    "Address": "124 CHOB",
    "WebsiteURL": "https://baumgartner.house.gov",
    "FacebookURL": "https://facebook.com/MichaelBaumgartnerWA",
    "XURL": "https://x.com/Baumgartner_WA",
    "State": "WA"
  },
  {
    "FirstName": "Emily",
    "LastName": "Randall",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-5916",
    "Address": "1531 LHOB",
    "WebsiteURL": "https://randall.house.gov",
    "FacebookURL": "https://facebook.com/EmilyRandallWA",
    "XURL": "https://x.com/emilyrandallwa",
    "State": "WA"
  },
  {
    "FirstName": "Pramila",
    "LastName": "Jayapal",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-3106",
    "Address": "2346 RHOB",
    "WebsiteURL": "https://jayapal.house.gov",
    "FacebookURL": "https://facebook.com/RepJayapal",
    "XURL": "https://x.com/RepJayapal",
    "State": "WA"
  },
  {
    "FirstName": "Kim",
    "LastName": "Schrier",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-7761",
    "Address": "1110 LHOB",
    "WebsiteURL": "https://schrier.house.gov",
    "FacebookURL": "https://facebook.com/RepKimSchrier",
    "XURL": "https://x.com/RepKimSchrier",
    "State": "WA"
  },
  {
    "FirstName": "Adam",
    "LastName": "Smith",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-8901",
    "Address": "2264 RHOB",
    "WebsiteURL": "https://adamsmith.house.gov",
    "FacebookURL": "https://facebook.com/RepAdamSmith",
    "XURL": "https://x.com/RepAdamSmith",
    "State": "WA"
  },
  {
    "FirstName": "Marilyn",
    "LastName": "Strickland",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-9740",
    "Address": "1724 LHOB",
    "WebsiteURL": "https://strickland.house.gov",
    "FacebookURL": "https://facebook.com/RepStricklandWA",
    "XURL": "https://x.com/RepStrickland",
    "State": "WA"
  },
  {
    "FirstName": "Carol",
    "LastName": "Miller",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3452",
    "Address": "465 CHOB",
    "WebsiteURL": "https://miller.house.gov",
    "FacebookURL": "https://facebook.com/RepCarolMiller",
    "XURL": "https://x.com/RepCarolMiller",
    "State": "WA"
  },
  {
    "FirstName": "Riley",
    "LastName": "Moore",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2711",
    "Address": "1337 LHOB",
    "WebsiteURL": "https://rileymoore.house.gov",
    "FacebookURL": "https://facebook.com/RileyMooreWV",
    "XURL": "https://x.com/RileyMooreWV",
    "State": "WA"
  },
  {
    "FirstName": "Bryan",
    "LastName": "Steil",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3031",
    "Address": "1526 LHOB",
    "WebsiteURL": "https://steil.house.gov",
    "FacebookURL": "https://facebook.com/RepBryanSteil",
    "XURL": "https://x.com/RepBryanSteil",
    "State": "WI"
  },
  {
    "FirstName": "Mark",
    "LastName": "Pocan",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-2906",
    "Address": "1026 LHOB",
    "WebsiteURL": "https://pocan.house.gov",
    "FacebookURL": "https://facebook.com/RepMarkPocan",
    "XURL": "https://x.com/repmarkpocan",
    "State": "WI"
  },
  {
    "FirstName": "Derrick",
    "LastName": "Van Orden",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5506",
    "Address": "1513 LHOB",
    "WebsiteURL": "https://vanorden.house.gov",
    "FacebookURL": "https://facebook.com/RepVanOrden",
    "XURL": "https://x.com/RepVanOrden",
    "State": "WI"
  },
  {
    "FirstName": "Gwen",
    "LastName": "Moore",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "D",
    "Phone": "(202) 225-4572",
    "Address": "2252 RHOB",
    "WebsiteURL": "https://gwenmoore.house.gov",
    "FacebookURL": "https://facebook.com/GwenMooreWI",
    "XURL": "https://x.com/RepGwenMoore",
    "State": "WI"
  },
  {
    "FirstName": "Scott",
    "LastName": "Fitzgerald",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5101",
    "Address": "2444 RHOB",
    "WebsiteURL": "https://fitzgerald.house.gov",
    "FacebookURL": "https://facebook.com/RepFitzgerald",
    "XURL": "https://x.com/RepFitzgerald",
    "State": "WI"
  },
  {
    "FirstName": "Glenn",
    "LastName": "Grothman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2476",
    "Address": "1211 LHOB",
    "WebsiteURL": "https://grothman.house.gov",
    "FacebookURL": "https://facebook.com/RepGrothman",
    "XURL": "https://x.com/RepGrothman",
    "State": "WI"
  },
  {
    "FirstName": "Thomas",
    "LastName": "Tiffany",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-3365",
    "Address": "451 CHOB",
    "WebsiteURL": "https://tiffany.house.gov",
    "FacebookURL": "https://facebook.com/RepTiffany",
    "XURL": "https://x.com/RepTiffany",
    "State": "WI"
  },
  {
    "FirstName": "Tony",
    "LastName": "Wied",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-5665",
    "Address": "424 CHOB",
    "WebsiteURL": "https://wied.house.gov",
    "FacebookURL": "https://facebook.com/TonyWiedWI",
    "XURL": "https://x.com/TonyWied",
    "State": "WI"
  },
  {
    "FirstName": "Harriet",
    "LastName": "Hageman",
    "Role": "Congress",
    "Division": "Federal",
    "Party": "R",
    "Phone": "(202) 225-2311",
    "Address": "1227 LHOB",
    "WebsiteURL": "https://hageman.house.gov",
    "FacebookURL": "https://facebook.com/RepHageman",
    "XURL": "https://x.com/RepHageman",
    "State": "WY"
  }
];

// 2. CAROUSEL SCROLLING
function scrollFMO(id, direction) {
  const container = document.getElementById(id);
  const card = container.querySelector('.official-card');
  if (card) {
    const scrollAmount = (card.offsetWidth + 12) * direction;
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }
} 

function updateNavButtons(carouselId) {
  const container = document.getElementById(carouselId);
  if (!container) return;

  const wrapper = container.parentElement;
  const prevBtn = wrapper.querySelector('.nav-btn.prev');
  const nextBtn = wrapper.querySelector('.nav-btn.next');

  const scrollLeft = container.scrollLeft;
  const maxScroll = container.scrollWidth - container.clientWidth;

  const atStart = scrollLeft <= 5;
  const atEnd = scrollLeft >= maxScroll - 5;

  if (prevBtn) prevBtn.disabled = atStart;
  if (nextBtn) nextBtn.disabled = atEnd;
}

// 3. VCARD EXPORT
function exportVCard(name, title, phone, url) {
  const vcard = `BEGIN:VCARD\nVERSION:3.0\nFN:${name}\nTITLE:${title}\nTEL;TYPE=WORK,VOICE:${phone}\nURL:${url}\nEND:VCARD`;
  const blob = new Blob([vcard], { type: "text/vcard;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${name.replace(/\s+/g, '_')}.vcf`;
  link.click();
  URL.revokeObjectURL(link.href);
}

function copyOfficial(name, role, phone, address, url) {
  const text = `${name}
${role}
Phone: ${phone || 'N/A'}
Address: ${address || 'N/A'}
Website: ${url || 'N/A'}`;

  navigator.clipboard.writeText(text);
}

// 4. CARD RENDERER (Updated for Pick 4)
function renderOfficialToCarousel(data, carouselId) {
  const container = document.getElementById(carouselId);
  if (!container) return;

  // Handles both "R/D" and "Republican/Democrat" for safety
  const partyClass = (data.Party?.startsWith('R')) ? 'bg-rep' : 
                     (data.Party?.startsWith('D')) ? 'bg-dem' : 'bg-ind';

  const cardHTML = `
    <div class="official-card">
      <div class="card-frame ${partyClass}"></div>
      <div class="card-body">
        <span class="mini-role">${data.Role ?? 'Official'}</span>
        <h4 class="mini-name ${partyClass === 'bg-rep' ? 'name-rep' : partyClass === 'bg-dem' ? 'name-dem' : 'name-ind'}">${data.FirstName ?? ''} ${data.LastName ?? ''}</h4>
        
        <div class="mini-stats">
          <p><strong>Phone:</strong> <a href="tel:${data.Phone ?? ''}">${data.Phone ?? 'Unknown'}</a></p>
          <p><strong>Address:</strong> ${data.Address ?? 'Unknown'}</p>
          <p><strong>Web:</strong> <a href="${data.WebsiteURL ?? '#'}" target="_blank" class="mini-link">${data.WebsiteURL ? new URL(data.WebsiteURL).hostname.replace('www.', '') : '—'}</a></p>
        </div>

        <div class="social-links">
          ${data.FacebookURL ? `<a href="${data.FacebookURL}" target="_blank" title="Facebook">
            <img src="${window.asset_url_base}fb-black.png" alt="FB">
          </a>` : ''}

          ${data.XURL ? `<a href="${data.XURL}" target="_blank" title="X (Twitter)">
            <img src="${window.asset_url_base}x-black.png" alt="X">
          </a>` : ''}
        </div>
      <div class="card-footer">
      <div style="display:flex; gap:6px; width:100%;">
        <button class="utility-btn" style="width:50%;" onclick="exportVCard('${data.FirstName ?? ''} ${data.LastName ?? ''}', '${data.Role ?? ''}', '${data.Phone ?? ''}', '${data.WebsiteURL ?? ''}')">+ CONTACT</button>
        <button class="utility-btn" style="width:50%;" onclick="copyOfficial('${data.FirstName ?? ''} ${data.LastName ?? ''}', '${data.Role ?? ''}', '${data.Phone ?? ''}', '${data.Address ?? ''}', '${data.WebsiteURL ?? ''}')">COPY</button>
      </div>
    </div>
    </div>
  `;
  container.insertAdjacentHTML('beforeend', cardHTML);
}

// 5. THE FILTER (Senate + Congress + Governor)
function loadStateData(stateCode) {
  // Clear existing cards
  document.getElementById('federal-carousel').innerHTML = '';
  document.getElementById('state-carousel').innerHTML = '';

  // SHOW RESULTS / HIDE BLANK STATE
  const blankState = document.getElementById('fyo-blank-state');
  const activeResults = document.getElementById('fyo-active-results');
  const resultsHeading = document.getElementById('fyoResultsHeading');

  const select = document.getElementById('stateSelect');
  const stateName = select?.selectedOptions?.[0]?.textContent?.trim() || stateCode;

  if (blankState) blankState.style.display = 'none';
  if (activeResults) activeResults.style.display = 'block';
  if (resultsHeading) resultsHeading.textContent = `Officials for ${stateName}`;

  // SENATE
  const senate = officialsData.filter(p =>
    p.State === stateCode &&
    p.Division === 'Federal' &&
    /senator/i.test(p.Role ?? '')
  );

  // CONGRESS
  const congress = officialsData.filter(p =>
    p.State === stateCode &&
    p.Division === 'Federal' &&
    /congress|representative|house/i.test(p.Role ?? '')
  );

  // GOVERNOR ...
  // GOVERNOR (goes in summary section)
  const governor = officialsData.find(p =>
    p.State === stateCode &&
    /governor/i.test(p.Role ?? '')
  );

  // Render Senate
  senate.forEach(person => renderOfficialToCarousel(person, 'federal-carousel'));

  // Render Congress
  congress.forEach(person => renderOfficialToCarousel(person, 'state-carousel'));

  // Populate Governor
  const governorName = document.getElementById('governor-name');
  const governorPhone = document.getElementById('governor-phone');
  const governorAddress = document.getElementById('governor-address');
  const governorWebsite = document.getElementById('governor-website');

  if (governor) {
    const governorImage = document.getElementById('governor-image-display');

    if (governorImage && window.asset_url_base) {
      const lastName = (governor.LastName ?? '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-');
      governorImage.src = `${window.asset_url_base}governor-${lastName}.jpg`;
    }
    
    const fullName = `${governor.FirstName ?? ''} ${governor.LastName ?? ''}`.trim();

    const govPartyClass =
      governor.Party?.startsWith('R') ? 'name-rep' :
      governor.Party?.startsWith('D') ? 'name-dem' :
      'name-ind';

    governorName.className = `sf-h3 ${govPartyClass}`;
    governorName.textContent = fullName || 'Governor';
    governorPhone.textContent = governor.Phone ?? '—';
    governorPhone.href = governor.Phone ? `tel:${governor.Phone}` : '#';
    governorAddress.textContent = governor.Address ?? '—';
    governorWebsite.href = governor.WebsiteURL ?? '#';
    governorWebsite.textContent = governor.WebsiteURL ? new URL(governor.WebsiteURL).hostname.replace('www.', '') : '—';

    } else {
      governorName.textContent = 'Governor not found';
      governorPhone.textContent = '—';
      governorPhone.href = '#';
      governorAddress.textContent = '—';
      governorWebsite.href = '#';
      governorWebsite.textContent = '—';
    }

      updateNavButtons('federal-carousel');
      updateNavButtons('state-carousel');
    }

// 6. STATE IMAGE HANDLER
function handleStateClick(stateName) {
  const imgElement = document.getElementById('state-image-display');
  const labelElement = document.getElementById('state-name-label');
  
  if (labelElement) labelElement.innerText = stateName;
  
  if (imgElement && window.asset_url_base) {
    const cleanName = stateName.replace(/\s+/g, '');
    imgElement.src = `${window.asset_url_base}state-${cleanName}.png`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // --- EXISTING: carousel scroll tracking ---
  ['federal-carousel', 'state-carousel'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;

    el.addEventListener('scroll', () => updateNavButtons(id));
  });

  // --- NEW: read ?state=XX from URL and load ---
  const params = new URLSearchParams(window.location.search);
  const state = params.get('state');

  if (state) {
    const select = document.getElementById('stateSelect');
    if (select) select.value = state;

    loadStateData(state);

    const selectedName = select?.selectedOptions?.[0]?.textContent?.trim();
    if (selectedName) handleStateClick(selectedName);

  }
});